import {
    isCIEnvironment, isDevEnvironment, isPublicCloudEnvironment, isMooncakeEnvironment,
    isFairfaxEnvironment, isBleuEnvironment, isDelosEnvironment, isPublicProdEnviroment, isAdfMooncakeEnvironment, isAdfFairfaxEnvironment, isAdfBleuEnvironment, isAdfDelosEnvironment, isA365LXEnvrionment,
    isStagingEnvironment
} from 'environments/environment.util';
import { parse, ParsedQuery } from 'query-string';
import { GitHubConstants } from './git/git-hub/git-hub-constants';
import { localStorageGet } from 'app/shared/utils/window.util';
import type { IThemeType } from 'app/theme/interfaces';
import { autosaveEnabledTypes, FabricEnvName, GlobalVariables as ShellGlobalVariables, getDPEFeatureFlag } from 'shell-models-lib';

export type ResourceType = 'sparkCompute' | 'sqlCompute' | 'sqlPool' | 'sqlDatabase' | 'bigDataPool' | 'sqlscript' | 'kqlscript' | 'notebook' | 'sparkjobdefinition' | 'scopejobdefinition'
    | 'linkedService' | 'pipeline' | 'dataset' | 'airflowEntity' | 'trigger' | 'integrationRuntime' | 'dataflow' | 'pbidataflow' | 'deployments' | 'workspace' | 'factory' | 'powerquery' | 'globalparameters'
    | 'managedPrivateEndpoint' | 'managedVirtualNetwork' | 'credential' | 'scopePool' | 'database' | 'table' | 'relationship' | 'linkconnection' | 'linktable'
    | 'sparkConfiguration' | 'dataMapper' | 'adfcdc' | 'pbinotebook' | 'dataWarehouse' | 'synapseNotebook' | 'copyjob' | 'MountedRelationalDatabase' | 'functionset' | 'environment' | 'SqlAnalyticsEndpoint' | 'dbtitem';

export const subResourceTypeMap: Partial<Record<string, ResourceType[]>> = {
    database: ['table', 'relationship']
};

export const safeCollaborationResourceTypes: ResourceType[] = ['notebook', 'sqlscript', 'kqlscript'];

export const CONTENT_TYPE = 'Content-Type';
export const AUTHORIZATION = 'Authorization';
export const DEPLOYMENT_RP_API_VERSION = '2017-05-10';
export const DEPLOYMENT_RESOURCE_TYPE = 'Microsoft.Resources/deployments';
export const FACTORY_FULLRESOURCE_TYPE = 'Microsoft.DataFactory/factories';
export const WORKSPACE_FULLRESOURCE_TYPE = 'Microsoft.Synapse/workspaces';
export const UAMI_FULLRESOURCE_TYPE = 'Microsoft.ManagedIdentity/userAssignedIdentities';
export const FACTORY_RESOURCE_TYPE = 'factories';
export const FACTORY_RESOURCE_PROVIDER = 'Microsoft.DataFactory';
export const PURVIEW_RESOURCE_PROVIDER = 'Microsoft.Purview';
export const WORKSPACE_RESOURCE_PROVIDER = 'Microsoft.Synapse';
export const WORKSPACE_RESOURCE_TYPE = 'workspaces';
export const CONFIGURE_REPO_RESOURCE_TYPE = 'Microsoft.DataFactory/locations/{0}/configureFactoryRepo';
export const MICROSOFT_TENANT_ID = '72f988bf-86f1-41af-91ab-2d7cd011db47'; // MSIT
export const MSAZURECLOUD_TENANT_ID = '33e01921-4d64-4f8c-a055-5bdaffd5e33d'; // AME
export const MSTORUS_TENANT_ID = 'cdc5aeea-15c5-4db6-b079-fcadd2505dc2'; // TORUS
export const PME_TENANT_ID = '975f013f-7f24-47e8-a7d3-abc4752bf346'; // PME
export const GME_TENANT_ID = '124edf19-b350-4797-aefc-3206115ffdb3'; // GME
export const COMMIT_TAG = '__LAST_PUBLISHED_COMMIT_ID___';
export const ADAPTER_VERSION20: string = '2.0.0';
export const TOUR_STEP_DISPLAYED: string = '{0}_tour_step_displayed_{1}';
export const FABRIC_ONBOARDING_SHOWN: string = '{0}_fabric_onboarding_shown_{1}';
export const SANDBOX_RUN_KEY: string = '{0}_{1}_sandbox_runId';
export const SANDBOX_RUNNING_NOTIFICATION_KEY: string = '{0}_{1}_sandbox_run_notification_Id';
export const PIPELINE_RUN_NOTIFICATION_KEY: string = '{0}_pipeline_run_notification_Id';
export const BRANCH_PREFFIX: string = 'refs/heads/';
export const MICROSOFT_PRODUCTION_ORIGIN: string = 'https://ms-adf.azure.com';
export const PRODUCTION_ORIGIN: string = 'https://adf.azure.com';
export const ADF_TEST_ORIGIN: string = 'https://atlas-preview.cloudapp.net';
export const ADF_CI_ORIGIN: string = 'https://madrid-ci.azure.com';
export const ADF_STAGING_ORIGIN: string = 'https://madrid-staging.azure.com';
export const FAIRFAX_TEST_ORIGIN: string = 'https://adftest2.azurewebsites.us';
export const FAIRFAX_PRODUCTION_ORIGIN: string = 'https://adf.azure.us';
export const MOONCAKE_TEST_ORIGIN: string = 'https://adftest2.azurewebsites.cn';
export const MOONCAKE_PRODUCTION_ORIGIN: string = 'https://adf.azure.cn';
export const USNAT_TEST_ORIGIN: string = 'https://adftest2.azurewebsites.eaglex.ic.gov';
export const USNAT_PRODUCTION_ORIGIN: string = 'https://adf.azure.eaglex.ic.gov';
export const USSEC_TEST_ORIGIN: string = 'https://adftest2.azurewebsites.microsoft.scloud';
export const USSEC_PRODUCTION_ORIGIN: string = 'https://adf.azure.microsoft.scloud';
export const WORKSPACE_CI_ORIGIN: string = 'https://web-ci.azuresynapse.net';
export const WORKSPACE_STAGING_ORIGIN: string = 'https://web-staging.azuresynapse.net';
export const WORKSPACE_PROD_ORIGIN: string = 'https://web.azuresynapse.net';
export const WORKSPACE_MICROSOFT_PROD_ORIGIN: string = 'https://ms.web.azuresynapse.net';
export const METRIC_ALERTS = 'Microsoft.Insights/metricalerts';
export const METRIC_DEFINITIONS = 'Microsoft.Insights/metricDefinitions';
export const METRICS = 'Microsoft.Insights/metrics';
export const METRIC_ACTIONGROUPS = 'Microsoft.Insights/actiongroups';
export const DATAFACTORY_GA_2018_06_01 = '2018-06-01';
export const DATAFACTORY_DATAFLOW = '2018-07-01-preview';
export const DATAFACTORY_PREVIEW_2017_09_01 = '2017-09-01-preview';
export const WORKSPACE_APIVERSION = '2019-06-01-preview';
export const WORKSPACE_ROLEASSIGNMENT_2020_08_01 = '2020-08-01-preview';
export const WORKSPACE_DATABASE_2021_04_01 = '2021-04-01';
export const WORKSPACE_WORKSPACE_2021_05_01 = '2021-05-01';
export const WORKSPACE_WORKSPACE_2021_06_01 = '2021-06-01';
export const RUNSTART_LOCAL_STORAGE_KEY = 'runStart_sortAsc';
export const WORKING_BRANCH_OLD_LOCAL_STORAGE_KEY = '{0}_{1}_workingBranch'; // deprecated
export const WORKING_BRANCH_LOCAL_STORAGE_KEY = '{0}_{1}_{2}_workingBranch';
export const RUN_PARAMETERS_STORAGE_KEY = '{0}_{1}_parameterValue';
export const AUTO_SAVE_TEACHING_BUBBLE_KEY = '{0}_{1}_auto_save_teaching_bubble';
export const DATAFACTORY_API_VERSIONS = [DATAFACTORY_PREVIEW_2017_09_01, DATAFACTORY_GA_2018_06_01, DATAFACTORY_DATAFLOW]; // In no particular order
export const POWERQUERY_DEFAULTQUERY = 'UserQuery';
export const API_VERSION_2019_PREVIEW = '2019-06-01-preview';
export const LAST_USED_FACTORY_KEY = 'savedLastUsedFactory';
export const LAST_USED_TENANT_KEY = 'savedLastUsedTenant';
export const LOCAL_STORAGE_ENABLE_DATA_FIRST = 'enableDataFirstViews';
export const PREFER_DATA_FIRST_CANVAS = 'preferDataFirstCanvas';
export const SQL_ERROR_STORAGE_PATH: string = 'sqlErrorStoragePath';
export const ASSERT_FAILURE_STORAGE_PATH: string = 'assertFailureStoragePath';
export const LOCAL_STORAGE_MONITORING_COLUMNS: string = 'pipelineRunsColumns';
export const LOCAL_STORAGE_DEBUG_MONITORING_COLUMNS: string = 'pipelineRunsDebugColumns';
export const TRIDENT_API_2022_01_01_PREVIEW = '2022-01-01-preview';
export const LOCAL_STORAGE_TIMEZONE = 'savedTimeZone';
export const PREVIEW_CALLOUT_SHOWN = '5x5calloutShown';
export const PREVIEW_CONTAINER_CALLOUT_SHOWN = '5x5containerCalloutShown';
export const RERUN_CALLOUT_SHOWN = '5x5rerunCalloutShown';
export const CONTAINER_EXPANDED_DEFAULT = '5x5containerActivityDefault';
export const CONNECTOR_VERSION20: string = '2.0';
export const FABRIC_BANNER_CLOSED: string = 'fabricBannerClosed';

export type IResourceTypeKey = 'ADFProvider' | 'UAMI';
export const resourceTypeMap: Record<IResourceTypeKey, string> = {
    ADFProvider: FACTORY_RESOURCE_PROVIDER,
    UAMI: UAMI_FULLRESOURCE_TYPE
};
export const resourceTypeList: string[] = [
    UAMI_FULLRESOURCE_TYPE,
    FACTORY_FULLRESOURCE_TYPE
];

function getLocationHref(): string {
    return window.location.href;
}

//
//   There are 3 main types of entries in the GlobalVariables section
//
//   A. public static variableName: boolean = /[\?&]feature\.featureName=true/i.test(getLocationHref());
//          These are set based on whether a feature has been included in the URL command - default value will be false.
//        These are referenced in the main code as GlobalVariables.variableName
//
//   B. private static _variableName:  boolean = /[\?&]feature\.featureName=true/i.test(getLocationHref());
//          These are set based on whether a feature has been included in the URL command - default value will be false.
//        The expectation is that these are referenced by the get operations
//
//   C. public static get variableName(): boolean {
//         return this._privateVariable || /[\?&]feature\.featureName=true/i.test(getLocationHref());
//      }
//          These are meant to handle variables that are based on multiple conditions
//        These are referenced in the main code as GlobalVariables.variableName
//

let queryObj: ParsedQuery = {};
try {
    queryObj = parse(window.location.search);
} catch (e) {
    //
}

export class GlobalVariables {

    public static dataFactoryVersion: string = DATAFACTORY_GA_2018_06_01;


    public static get isDogfood(): boolean {
        return ShellGlobalVariables.isDogfood;
    }

    public static get isMicrosoftInternal(): boolean {
        return ShellGlobalVariables.isMicrosoftInternal;
    }

    public static get fabricEnv(): FabricEnvName | undefined {
        return ShellGlobalVariables.fabricEnv;
    }

    public static thirdPartyCookiesBlocked: boolean = false;

    public static showAllFeatures: boolean = /[\?&]feature\.development=true/i.test(getLocationHref());

    public static dataflowFeature: boolean = /[\?&]feature\.dataflow=true/i.test(getLocationHref());

    public static dataflowSplitScript: boolean = /[\?&]feature\.dataflowSingleScript=true/i.test(getLocationHref());

    public static isResourceDeleteLocked: boolean = false;

    /* Keep this feature flag and always set to false, could be used to debug Madrid loading issue
       When enableDebugMode = true, backgroundFetch and showPipelineTriggerCount are disabled to avoid fetching all nameds at the beginning
    */
    public static enableDebugMode: boolean = /[\?&]feature\.enableDebugMode=true/i.test(getLocationHref());

    // Owner: victrorlee, 01/24/2024 - feature flags iceberg format, for dataflow
    public static enableIcebergFormat: boolean = /[\?&]feature\.enableIcebergFormat=true/i.test(getLocationHref());

    // Owner: anbulusu, 10/07/2024 - feature flags enable HDI MSI format
    public static enableHDIMSI: boolean = /[\?&]feature\.enableHDIMSI=true/i.test(getLocationHref());

    // Owner: nramanathan, 28/03/2025 - feature flags HDInsight Linked Storage Account Auth Validations
    public static enableHDIStorageLSAuthValidate: boolean = /[\?&]feature\.enableHDIStorageLSAuthValidate=true/i.test(getLocationHref());

    // Owner: nramanathan, 07/05/2025 - feature flags HDInsight cluster MI auth
    public static enableHDIClusterMIAuth: boolean = !(/[\?&]feature\.enableHDIClusterMIAuth=false/i.test(getLocationHref()));

    // Owner: nramanathan, 07/05/2025 - feature flags HDInsight API version upgrade
    public static enableHDIApiUpgrade: boolean = /[\?&]feature\.enableHDIApiUpgrade=true/i.test(getLocationHref());

    //Owner: nramanathan, 07/30/2025 - feature flags HDInsight get cluster auth type at runtime
    public static getHDIAuthTypeAtRuntime: boolean = /[\?&]feature\.getHDIAuthTypeAtRuntime=true/i.test(getLocationHref());

    public static showVNetIRAllRegions: boolean = /[\?&]feature\.vnetirregions=true/i.test(getLocationHref());

    public static showSapTableRowSkipWithFF: boolean = /[\?&]feature\.saptableRowSkip=true/i.test(getLocationHref());

    public static enableTriggerRerunRange: boolean = /[\?&]feature\.triggerrerunrange=true/i.test(getLocationHref());

    public static enableAdobeIntegration: boolean = /[\?&]feature\.adobe=true/i.test(getLocationHref());

    // Debug-only helper on the entry page that generates an ADF-audience token for local API testing.
    // Restricted to CI, dogfood/staging, and local `ng serve` builds; opt in with `?feature.debugTokenGenerator=true`.
    public static enableDebugTokenGenerator: boolean =
        (isCIEnvironment() || GlobalVariables.isDogfood || isDevEnvironment()) &&
        /[\?&]feature\.debugTokenGenerator=true/i.test(getLocationHref());

    public static enableRefreshDataflowAdf: boolean = /[\?&]feature\.RefreshDataflowAdf=true/i.test(getLocationHref());

    public static enableSamiSupport: boolean = ShellGlobalVariables.enableSamiSupport;

    public static redirectMicrosoft: boolean = !(/[\?&]feature\.customportal=false/i.test(getLocationHref())); // don't remove this, for debug use

    public static enableMicrosoftInternalSites: boolean = /[\?&]feature\.enableinternalsites=true/i.test(getLocationHref()); // don't remove this, for debug use

    public static enableTableNameSplitForHubspotV2: boolean = /[\?&]feature\.splitTableNameForHubspotV2=true/i.test(getLocationHref());

    public static enableLoadingDynamicPluginFromService: boolean = /[\?&]feature\.enableLoadingDynamicPluginFromService=true/i.test(getLocationHref());

    public static enableLoadingDynamicPluginFromLocalStorage: boolean = /[\?&]feature\.enableLoadingDynamicPluginFromLocalStorage=true/i.test(getLocationHref());

    public static enableLoadingDynamicPluginForDev: boolean = /[\?&]feature\.enableLoadingDynamicPluginForDev=true/i.test(getLocationHref());

    public static enableDatabricksInitScriptAbfss: boolean = /[\?&]feature\.enableDatabricksInitScriptAbfss=true/i.test(getLocationHref());

    // Owner: blairch, 2026/06/05
    public static enableDatabricksClusterLogVolumes: boolean =
        /[\?&]feature\.adbClusterLogVolumes=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;

    public static enableDatabricks: boolean = (getDPEFeatureFlag('CDB') ?? true) && __IS_FABRIC_DPE__;
    public static enableDatabricksOAuth: boolean = GlobalVariables.enableDatabricks && getDPEFeatureFlag('DBOAuth');

    public static enableFirstClassConnector: boolean = /[\?&]feature\.enableFirstClassConnector=true/i.test(getLocationHref());

    public static enableM365: boolean = getDPEFeatureFlag('m365'); // We hide M365 for Fabric internal (DXT and MSIT) by default. We can enable it with this feature flag

    public static enableNewEC: boolean = /[\?&]feature\.newEC=true/i.test(getLocationHref()) || isStagingEnvironment() || GlobalVariables.isMicrosoftInternal;

    // Owner: fangl - Explicit-capacity variant of View in Fabric. Reuses an existing capacity selected
    // by the user, with trial creation separately controlled by fdf3. Both are on by default; pass the
    // corresponding `?feature.fdf2=false` or `?feature.fdf3=false` flag to opt out.
    public static enableFabricCapacitySelectionProvisioning: boolean = !/[\?&]feature\.fdf2=false/i.test(getLocationHref())
        && !__IS_A365__ && isPublicCloudEnvironment();

    public static enableFabricTrialCapacityCreation: boolean = GlobalVariables.enableFabricCapacitySelectionProvisioning
        && !/[\?&]feature\.fdf3=false/i.test(getLocationHref());

    public static enableFabricF0CapacityCreation: boolean = GlobalVariables.enableFabricCapacitySelectionProvisioning
        && /[?&]feature\.f0=true(?:[&#]|$)/i.test(getLocationHref());

    public static enableFabricTrialEligibilityCheck: boolean = GlobalVariables.enableFabricCapacitySelectionProvisioning
        && /[?&]feature\.fdf4=true(?:[&#]|$)/i.test(getLocationHref());

    // Owner: fangl - Shared entry-point gate for the Fabric Data Factory (FDF) experience. `fdf` keeps
    // the legacy trial auto-provisioning flow; `fdf2` enables the explicit-capacity variant.
    public static enableFabricTrialProvisioning: boolean = (
        /[\?&]feature\.fdf=true/i.test(getLocationHref())
        || GlobalVariables.enableFabricCapacitySelectionProvisioning
    ) && !__IS_A365__ && isPublicCloudEnvironment();

    // Owner: fangl - When the legacy mount flow (mount redirect / migration analysis / management hub)
    // fails with 403 FeatureNotAvailable (no trial/paid capacity), this flag enables automatic trial
    // capacity provisioning before retrying the mount. If provisioning also fails, the user is redirected
    // to the Fabric portal to complete the mount. Kept separate from `enableFabricTrialProvisioning` so the
    // ADF "View in Fabric" release does not activate this retry in surfaces (e.g. Synapse) where the
    // capacity flow may not be ready. Off by default. Pass `?feature.enableFabricMountTrialRetry=true` to opt in.
    public static enableFabricMountTrialRetry: boolean = /[\?&]feature\.enableFabricMountTrialRetry=true/i.test(getLocationHref());

    // Owner: fangl - Switches the "View in Fabric" onboarding to the simplified My Workspace strategy: instead of
    // provisioning a trial capacity + dedicated workspace + reader sync, it mounts the factory into the current
    // user's personal My Workspace (Fabric type `Personal`, capacity-free). Layers on top of
    // `enableFabricTrialProvisioning` (the entry points stay gated on that flag); the My Workspace path is only
    // taken when both are on, so this flag never changes the existing trial-provisioning behavior on its own.
    // Off by default. Pass `?feature.myworkspace=true` to opt in.
    public static enableFabricMyWorkspaceMount: boolean = /[\?&]feature\.myworkspace=true/i.test(getLocationHref());

    // Owner: fangl - Per-factory cap on the TOTAL number of Fabric mounts stored on the factory object
    // (the whole mountedConfiguration array, not just My Workspace mounts), to bound the factory object
    // size. Only blocks creating a NEW mount; existing mounts still open. Numeric URL flag
    // `feature.factoryMountLimit=<n>` (getDPEFeatureFlag is boolean-only, so parse the URL directly,
    // mirroring `mirrorParallelTableValidationConcurrency`). Defaults to 100, clamped to >= 1.
    public static fabricFactoryMountLimit: number = (() => {
        const match = /[?&]feature\.factoryMountLimit=(\d+)/i.exec(getLocationHref());
        const parsed = match ? Number(match[1]) : NaN;
        return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : 100;
    })();

    // shir name of which ir the plugin metadata is fetching
    public static shirForDynamicPluginDebug: string = /[\?&]feature\.shirForDynamicPluginDebug=(.+?)(?:$|&)/i.exec(getLocationHref())?.[1];

    // plugin types need to load from shir
    public static dynamicPluginTypes: string = /[\?&]feature\.dynamicPluginTypes=(.+?)(?:$|&)/i.exec(getLocationHref())?.[1];

    public static featureFeedbackStudiesFeatureFlag: boolean = /[\?&]feature\.featureFeedback=/i.test(getLocationHref())
        ? /[\?&]feature\.featureFeedback=true/i.test(getLocationHref())
        : undefined;

    public static bagNpsSurveyDefaultValue: boolean = !GlobalVariables.isDogfood && isPublicProdEnviroment();
    public static bagNpsSurveyFeatureOffFlag: boolean = /[\?&]feature\.npsOff=/i.test(getLocationHref())
        ? /[\?&]feature\.npsOff=true/i.test(getLocationHref())
        : undefined;
    public static bagNpsTesting: boolean = /[\?&]feature\.bagNpsTesting=true/i.test(getLocationHref()); // use int account for testing purpose
    public static bagNpsClearCache: boolean = /[\?&]feature\.bagNpsClearCache=true/i.test(getLocationHref()); // use int account for testing purpose

    // Don't clean up this. Keep it for workaround
    // Synapse doesn't support ADF dataplane
    public static enableDataPlane: boolean = !(/[\?&]feature\.enableDataPlane=false/i.test(getLocationHref())) && !__IS_A365__ && !__IS_FABRIC_DPE__; // Do not clean up, needed for testing

    public static isCmdApiApp: boolean = false;
    public static enableIFrameMode: boolean = ShellGlobalVariables.enableIFrameMode; // don't clean up this
    public static authDisabled: boolean = /[\?&]authDisabled=true/i.test(getLocationHref()) || GlobalVariables.enableIFrameMode; // don't clean up this

    public static enableAriaLogger: boolean = __IS_A365__
        ? isPublicCloudEnvironment()
        : !__IS_FABRIC_DPE__ && !__IS_FABRIC_MDF__;
    public static chainingTrigger: boolean = /[\?&]feature\.chainingTrigger=true/i.test(getLocationHref());

    public static enableAepInternal: boolean = /[\?&]feature\.enableAepInternal=true/i.test(getLocationHref());

    public static expressionValidation: boolean = getDPEFeatureFlag('expressionValidation') ?? true; // Don't clean up this. Keep it for workaround
    public static twtWindowValidation: boolean = /[\?&]feature\.twtWindowValidation=true/i.test(getLocationHref());
    public static enableUndo: boolean = /[\?&]feature\.enableUndo=true/i.test(getLocationHref());

    public static globalParametersImport: boolean = /[\?&]feature\.globalParametersImport=true/i.test(getLocationHref());

    public static showImportFromSupportFiles: boolean = /[\?&]feature\.showImportFromSupportFiles=true/i.test(getLocationHref()) || isDevEnvironment() || isCIEnvironment();

    public static enableDataFlowVersionFlag: boolean = /[\?&]feature\.enableDataFlowVersion=true/i.test(getLocationHref());

    // Owner: jenqiao, 15/12/22
    public static tridentBatch1ConnectorPhase2: boolean = /[\?&]feature\.batch1Connector2=true/i.test(getLocationHref()); // batch 1 connectors pending on PQ team
    public static enableSalesforceMDF: boolean = /[\?&]feature\.enableSalesforceMDF=true/i.test(getLocationHref()); // Salesforce MDF (dataflow)
    public static enableOpenMirrorSink: boolean = /[\?&]feature\.enableOpenMirrorSink=true/i.test(getLocationHref());
    public static pageSizeSf: boolean = /[\?&]feature\.showSalesforcePageSize=true/i.test(getLocationHref()); // expose salesforce pageSize to UI for Madrid only
    public static copilotConnectorsPhase2: boolean = getDPEFeatureFlag('copilotConnectorsPhase2');
    public static supportFic: boolean = /[\?&]feature\.supportFic=true/i.test(getLocationHref());  // ADF only
    public static oracleAutoCreate: boolean = getDPEFeatureFlag('OAC') || __IS_FABRIC_DPE__;
    public static oracleUpsert: boolean = getDPEFeatureFlag('OUp') || __IS_FABRIC_DPE__;
    public static snowflakeRoleCopyJob: boolean = getDPEFeatureFlag('SRCJ') || __IS_FABRIC_DPE__;
    public static shiftMultiSelect: boolean = getDPEFeatureFlag('SMS') && __IS_FABRIC_DPE__;
    public static gbqAutoCreate: boolean = getDPEFeatureFlag('GBQAC') && __IS_FABRIC_DPE__;
    public static cdfAutoCreate: boolean = (getDPEFeatureFlag('CDFAC') ?? true) && __IS_FABRIC_DPE__;

    // Set this to enabled dataflow debugging on a single session, while developing code.
    public static hardCodedDebugSessionId: string =
        isDevEnvironment() && /[\?&]feature\.debugSessionId=(.+?)(?:$|&)/i.test(getLocationHref())
            ? decodeURIComponent(/[\?&]feature\.debugSessionId=(.+?)(?:$|&)/i.exec(getLocationHref())?.[1])
            : undefined;

    // confirmed with BE owner, we won't release this feature, keep ff here for a period of time..
    public static enableNetezzaPrefetch: boolean = /[\?&]feature\.enableNetezzaPrefetch=true/i.test(getLocationHref());

    // Owner: noshapir, 23/4/2021 - use synapse feature flag to enable kql script loading
    public static enableKqlScript: boolean = (__IS_A365__ && !/[\?&](feature\.)?(useKql|showKustoPool)=false/i.test(getLocationHref()) && isPublicCloudEnvironment());

    // Owner: mablumen, 6/9/2021 - feature flags for Power Query GA updates
    public static enablePQRegion: boolean = (/[\?&]feature\.pqRegion=true/i.test(getLocationHref()));
    public static enablePQConversion: boolean = /[\?&]feature\.pqConversion=true/i.test(getLocationHref());
    public static enablePQPartitionByFileName: boolean = (/[\?&]feature\.pqPartitionByFileName=true/i.test(getLocationHref()));
    public static powerquery: boolean = /[\?&]feature\.enablepowerquery=true/i.test(getLocationHref());
    public static enablepowerQueryActivity: boolean = /[\?&]feature\.powerQueryActivity=true/i.test(getLocationHref());
    public static enableDataMapperinADF: boolean = /[\?&]feature\.enableADFDataMapper=true/i.test(getLocationHref());
    public static enableCDCADFDataMapperEdit: boolean = /[\?&]feature\.enableADFDataMapperEdit=true/i.test(getLocationHref());
    public static enableCDCADFDataMapperInitialLoad: boolean = /[\?&]feature\.enableADFDataMapperInitialLoad=true/i.test(getLocationHref());
    public static enableCDCADFDataMapperLakehouse: boolean = /[\?&]feature\.enableCDCADFDataMapperLakehouse=true/i.test(getLocationHref());
    public static enableCDCSQLDW: boolean = /[\?&]feature\.enableCDCSQLDW=true/i.test(getLocationHref());

    // Owner: kanikagupta, feature flags for ADF connectors
    public static enableShopifyV2: boolean = !(/[\?&]feature\.enableShopifyV2=false/i.test(getLocationHref()));
    public static enableQueryShopifyV2: boolean = !(/[\?&]feature\.enableQueryShopifyV2=false/i.test(getLocationHref()));

    // Owner: saumya, feature flags for tabular V2 batch size support
    public static enableHiveV2BatchSize: boolean = /[\?&]feature\.enableHiveV2BatchSize=true/i.test(getLocationHref());
    public static enableHiveV2QueryTimeout: boolean = /[\?&]feature\.enableHiveV2QueryTimeout=true/i.test(getLocationHref());
    public static enableImpalaV2BatchSize: boolean = /[\?&]feature\.enableImpalaV2BatchSize=true/i.test(getLocationHref());
    public static enableImpalaV2QueryTimeout: boolean = /[\?&]feature\.enableImpalaV2QueryTimeout=true/i.test(getLocationHref());

    public static enableQueryJiraV2: boolean = /[\?&]feature\.enableQueryJiraV2=true/i.test(getLocationHref());
    public static enableSparkV2BatchSize: boolean = /[\?&]feature\.enableSparkV2BatchSize=true/i.test(getLocationHref());
    public static enableSparkV2QueryTimeout: boolean = /[\?&]feature\.enableSparkV2QueryTimeout=true/i.test(getLocationHref());

    // Owner: Data Integration App, 2025/12/29 - feature flag to enable SASL and Binary thrift transport protocol support for Spark v2 linked service.
    public static enableSparkV2SaslAndBinary: boolean = /[\?&]feature\.enableSparkV2SaslAndBinary=true/i.test(getLocationHref());

    // Download support files for all dataflows
    public static downloadMultipleSupportFiles: boolean = /[\?&]feature\.downloadMultipleSupportFiles=true/i.test(getLocationHref());

    // Owner: mablumen. 10/11/2022 - feature flag for simplify monitoring feautre
    public static simplifyMonitoringFlag: boolean = /[\?&]feature\.simplifyMonitoring=true/i.test(getLocationHref());

    // Owner: mablumen. 2022/08/11
    public static lazyLoadingForDebugFlag: boolean = (/[\?&]feature\.lazyLoadingForDebug=true/i.test(getLocationHref()));

    // Owner: mablumen. 2024/01/31
    public static authorPerfImproveFlag: boolean = !(/[\?&]feature\.authorPerfImprove=false/i.test(getLocationHref()));

    // Owner: sekrantz. 2026/03/23
    public static enableRunConditions: boolean = /[\?&]feature\.runConds=true/i.test(getLocationHref());

    // Owner: kaelinhoang. 2026/09/24
    public static fabricTwt: boolean = /[\?&]feature\.fabricTwt=true/i.test(getLocationHref());

    // Onwer: mablumen. 2025/09/08
    public static enableDbtDmts: boolean = /[\?&]feature\.dbtDmts=true/i.test(getLocationHref());

    // Owner: mablumen. 2025/09/13
    public static enableDbtSchemaSelect: boolean = /[\?&]feature\.dbtSchemaOpts=true/i.test(getLocationHref());

    // Owner: mablumen, 2026/02/26 - new dbt job adapters
    public static enableDbtLakehouse: boolean = /[\?&]feature\.dbtLakehouse=true/i.test(getLocationHref());
    public static enableDbtFabricSql: boolean = /[\?&]feature\.dbtFabricSql=true/i.test(getLocationHref());

    // jenqiao, 2/28/22 - teradata query timeout field in copy source
    public static enableTeradataQueryTimeout: boolean = /[\?&]feature\.enableTeradataQueryTimeout=true/i.test(getLocationHref());

    public static enableCopySapOdpWithFF: boolean; //= /[\?&]feature\.enableSapOdp=true/i.test(getLocationHref());

    public static turnOffWebWorker: boolean = /[\?&]feature\.turnOffWebWorker=true/i.test(getLocationHref());

    public static tsqlStreamingEnabled: boolean = /[\?&]feature\.TSQLStreamingEnabled=true/i.test(getLocationHref());

    public static activityIRNodeMonitoring: boolean = /[\?&]feature\.activityIRNodeMonitoring=true/i.test(getLocationHref());

    public static validateDataFlowAPI: boolean = /[\?&]feature\.validateDataFlow=true/i.test(getLocationHref());

    public static enableMonitoringSparkUILink: boolean = /[\?&]feature\.monitoringSparkUILink=true/i.test(getLocationHref());

    public static enableTransientColumns: boolean = /[\?&]feature\.enableTransientColumns=true/i.test(getLocationHref());

    public static enableGetStarted: boolean = /[\?&]feature\.getStartedEnable=true/i.test(window.location.search);

    public static enableAllowCaching: boolean = /[\?&]feature\.enableAllowCaching=true/i.test(window.location.search);

    public static enableCopyStagingBlobSPN: boolean = /[\?&]feature\.enableCopyStagingBlobSPN=true/i.test(getLocationHref());

    public static enableSocPreviewFeatures: boolean = /[\?&]feature\.enableSocPreviewFeatures=true/i.test(getLocationHref());

    public static enableGroup: boolean = /[\?&]feature\.group=true/i.test(getLocationHref());

    public static enableNewSparkGraph: boolean = /[\?&]feature\.enableNewSparkGraph=true/i.test(getLocationHref());

    public static enableCosmosDBASForCDC: boolean = /[\?&]feature\.enableCosmosDBASForCDC=true/i.test(getLocationHref());

    public static enableCosmosDBForMongoDB: boolean = /[\?&]feature\.enableCosmosDBForMongoDB=true/i.test(getLocationHref());

    public static enforcedAppId: RegExpExecArray | null = /[\?&]appId=(\w+)/i.exec(getLocationHref());

    public static dataFlowSchemaTimeout: number = 300;

    public static dataFlowConnectionTimeout: number = 300;

    public static tumblingWindowDependencyCount: number = 5;

    public static enableA365Renaming: boolean = !/[\?&]enableA365Renaming=false/i.test(getLocationHref()) && !isMooncakeEnvironment();  // Do not clean up, leave for Fang

    public static enableUAMICreation: boolean = /[\?&]feature\.enableUAMI=true/i.test(getLocationHref());

    // 2021-04-23 yuwwang: sql dataplane permission change
    public static enableSqlDataPlaneApi: boolean = (/[\?&]feature\.sqldataplane=true/i.test(getLocationHref()));

    public static enableDataFlowMonitorImport: boolean = /[\?&]feature\.dataFlowMonitorImport=true/i.test(getLocationHref());

    // 2023-06-28 loganlasiter: hide user auth option from users
    public static lakehouseUserAuthEnabled: boolean = /[\?&]feature\.lakehouseUserAuthEnabled=true/i.test(getLocationHref());

    public static enableUseSchema: boolean = (/[\?&]feature\.enableUseSchema=true/i.test(getLocationHref()));

    public static enableOpenInNotebook: boolean = /[\?&]feature\.enableOpenInNotebook=true/i.test(getLocationHref());
    public static enableNewTeachingBubble: boolean = /[\?&]feature\.newBubble=true/i.test(getLocationHref());

    public static enableSsisIrVNetV2FeatureWithFF: boolean = /[\?&]feature\.enableSsisIrVNetV2Feature=true/i.test(getLocationHref());

    //ymrudul, 2026/07/01 - feature flag for web activity header dropdown
    public static enableWebActivityHeaderDropdown: boolean = getDPEFeatureFlag('WAHD')
        || /[\?&]feature\.webActivityHeaderDropdown=true/i.test(getLocationHref());

    // Owner: vinaggarwal, 2022/09/15
    public static enableWebActivityLS: boolean = /[\?&]feature\.enableWebActivityLS=true/i.test(getLocationHref());
    public static enableWebConnection: boolean = getDPEFeatureFlag('enableWC');
    public static _enableNewWebActivityLS: boolean = /[\?&]feature\.enableNewWebActivityLS=true/i.test(getLocationHref());
    public static enableAKV: boolean = /[\?&]feature\.enableAKV=true/i.test(getLocationHref());
    public static blobInWeb: boolean = /[\?&]feature\.blobInWeb=true/i.test(getLocationHref());
    public static functionSet: boolean = /[\?&]feature\.functionSet=true/i.test(getLocationHref());
    public static enableDFConnection: boolean = getDPEFeatureFlag('DFDMTS');
    public static enableDataflowConnection: boolean = getDPEFeatureFlag('DataflowDMTS');
    public static enableWIForWebBasedActivities: boolean = getDPEFeatureFlag('wiWebBased');
    public static enableWIForCustomML: boolean = getDPEFeatureFlag('wiCustomML');
    public static enableWIForDF: boolean = getDPEFeatureFlag('wiDF');
    public static enableSparkSettingsForNB: boolean = getDPEFeatureFlag('sparkNB');
    public static enableSparkSettingsMigrationInSynapse: boolean = /[\?&]feature\.sparkNBMigration=true/i.test(getLocationHref())
        || (__IS_A365__ && (isDevEnvironment() || isCIEnvironment() || isStagingEnvironment()));
    public static microsoftTeams: boolean = /[\?&]feature\.teams=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;
    public static enableApprovalActivity: boolean = /[\?&]feature\.approval=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;
    public static enableAirflowActivity: boolean = /[\?&]feature\.airflowActivity=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;
    public static enableDataQualityActivity: boolean = /[\?&]feature\.dataQuality=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;

    // Owner: dvachhani, 2024/05/30
    public static updateAzFuncSAMI: boolean = /[\?&]feature\.updateAzFuncSAMI=true/i.test(getLocationHref());
    public static enableOPDGForInvokeCopyJob: boolean = getDPEFeatureFlag('opdgCjActivty');
    public static enableUserAuthForNotebookConnection: boolean = /[\?&]feature\.NbUser=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;
    public static enableUserAuthForSJDConnection: boolean = /[\?&]feature\.SJDUser=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;
    public static enableKeyPairAuthForSFTP: boolean = /[\?&]feature\.sftpKeyPairAuth=true/i.test(getLocationHref());
    public static enforceConnectionForNewActivity: boolean = /[\?&]feature\.reqConn=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;
    public static office365Email: boolean = /[\?&]feature\.email=true/i.test(getLocationHref());
    public static enableSPNForOffice365Email: boolean = /[\?&]feature\.emailSPN=true/i.test(getLocationHref());
    public static enableSPNForMicrsoftTeams: boolean = /[\?&]feature\.teamsSPN=true/i.test(getLocationHref());
    public static enableSPNforRefreshSQLEndpoint: boolean = /[\?&]feature\.sqlEndPtSPN=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;
    public static enableWIforRefreshSQLEndpoint: boolean = /[\?&]feature\.sqlEndPtWI=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;

    // Owner: arsunda, 2026/08/21 fabric web extensibility for actions apis
    public static enableApiIntegrationActivity: boolean = (/[\?&]feature\.fabricWeb=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__);
    public static enableFabricActionsActivity: boolean = /[\?&]feature\.(fabricActions|EnableFabricActionActivityInPipeline)=true/i.test(getLocationHref()) &&
        __IS_FABRIC_DPE__;
    public static enableBusinessActionsActivity: boolean = /[\?&]feature\.(fabricActions|EnableBusinessActionActivityInPipeline)=true/i.test(getLocationHref()) &&
        __IS_FABRIC_DPE__;
    // An explicit URL value overrides the chooser EC; otherwise its release remains EC-controlled.
    public static enableFabricActionPicker: boolean | undefined = getDPEFeatureFlag('fabricActionPicker');

    // Owner: sakshitomar, 2026/04/09
    public static enableRefreshTypeSemanticModel: boolean =  /[\?&]feature\.refreshtype=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;
    public static enableSparkSettingsForSJD: boolean = getDPEFeatureFlag('sparkSJD');
    public static enableFailOnEmptyOutputCopyjob: boolean = /[\?&]feature\.FailOnEmptyOutput=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;

    public static enableOPDGForRefreshSQLEndpoint: boolean = /[\?&]feature\.opdgSqlEndPt=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;

    public static enableSynapseMetadataPush: boolean = /[\?&]feature\.enableSynapseMetadataPush=true/i.test(getLocationHref()) && __IS_A365__;

    public static enableSynapseSparkLineage: boolean = /[\?&]feature\.enableSynapseSparkLineage=true/i.test(getLocationHref()) && __IS_A365__;

    public static enableADFSparkGatewayWithFF: boolean = /[\?&]feature\.enableDataFlowInAllRegions=true/i.test(getLocationHref());

    public static enableADFSparkGatewayManagedVnetWithFF: boolean = /[\?&]feature\.enableADFSparkGatewayManagedVnet=true/i.test(getLocationHref());

    public static enableADFSparkGatewayMultiRegionWithFF: boolean = /[\?&]feature\.enableADFSparkGatewayMultiRegion=true/i.test(getLocationHref());

    public static enableADFSparkGatewayQuickReuseWithFF = /[\?&]feature\.enableADFSparkGatewayQuickReuse=true/i.test(getLocationHref());

    public static enableSJDSparkConfigArtifact: boolean = /[\?&]feature\.enableSJDSparkConfigArtifact=true/i.test(getLocationHref());

    public static enableNotebookSparkConfigOverride: boolean = /[\?&]feature\.enableNotebookSparkConfigOverride=true/i.test(getLocationHref()) || getDPEFeatureFlag('nbSparkConfig');

    public static enableSynapseLinkedServiceUami: boolean = /[\?&]feature\.enableSynapseLinkedServiceUami=true/i.test(getLocationHref());

    // Owner: lirsun, 2021/04/02, expand all folder by default in moveTo panel when `enableMoveToToggle` is `true`
    public static expandAllFolders: boolean = (/[\?&]feature\.expandAllFolders=true/i.test(getLocationHref()));

    // Owner : raprade, arsunda 2021/07/30, add airflow ui under preview
    public static airflowWithFF: boolean = /[\?&]feature\.airflow=true/i.test(getLocationHref());

    // Owner : joavelar 2022/01/21, add airflow entity ui under preview
    public static airflowEntity: boolean = /[\?&]feature\.airflowEntity=true/i.test(getLocationHref());

    // Owner : joavelar 2023/04/04, airflow v1 flag
    public static airflowV1: boolean = /[\?&]feature\.airflowV1=true/i.test(getLocationHref());

    // Owner : arsunda, joavelar 2023/04/04, airflow autoscale flag
    public static airflowAutoscale: boolean = /[\?&]feature\.AirflowAutoscale=true/i.test(getLocationHref());

    // Owner : arsunda, joavelar 2023/04/04, airflow autoscale on existing clusters flag
    public static airflowAutoscaleUpdate: boolean = /[\?&]feature\.AirflowAutoscaleUpdate=true/i.test(getLocationHref());

    // Owner :  joavelar 2023/10/12, airflow clear storage during import
    public static airflowClearStorage: boolean = /[\?&]feature\.AirflowClearStorage=true/i.test(getLocationHref());

    // Owner : fengqi, 2021/10/13, flag for external users to browse Gen1 storage
    public static enableExploreGen1: boolean = /[\?&]feature\.exploreADLSGen1=true/i.test(getLocationHref());

    public static enableSwitchAccount: boolean = /[\?&]feature\.enableSwitchAccount=true/i.test(getLocationHref());

    // Owner: jmcallister, 2021/05/28, add validation to unblock customer for https://portal.microsofticm.com/imp/v3/incidents/details/242466863/home
    public static enableParameterUndefinedValidation: boolean = /[\?&]feature\.enableParameterUndefinedValidation=true/i.test(getLocationHref());

    // Owner: t-khoang, 2021/06/01, Add performance tuning page in monitoring
    public static allowPerformanceTuning: boolean = (/[\?&]feature\.enablePerformanceTuning=true/i.test(getLocationHref()));

    // Owner: nimoolen, 2021/06/04, allow customers to bypass the timeout in activity run API calls
    public static bypassActivityRunTimeout: boolean = (/[\?&]feature\.bypassActivityRunTimeout=true/i.test(getLocationHref()));

    public static enableOnlyStagingSchemaSink: boolean = (/[\?&]feature\.enableOnlyStagingSchemaSink=true/i.test(getLocationHref()));

    public static get isStagingSchemaEnabledForSink(): boolean { return this.enableOnlyStagingSchemaSink; }

    // Owner: akv, 2023/08/09, enable stateful surrogate key
    public static enableStatefulSurrogateKey: boolean = (/[\?&]feature\.enableStatefulSurrogateKey=true/i.test(getLocationHref()));
    public static get isStatefulSurrogateKeyEnabled(): boolean { return this.enableStatefulSurrogateKey; }

    // Owner: dvachhani, 2022/09/26, Workday connector
    public static enableWorkday: boolean = /[\?&]feature\.enableWorkday=true/i.test(getLocationHref());

    // 2022/12/15, Disabled by default for everyone and can be enabled only via feature flag
    public static get isWorkdayEnabled(): boolean { return this.enableWorkday; }

    // Owner: yuanjieluo, 2021/12/22, SharePoint online File connector
    public static enableSharePointOnlineFileWithFF: boolean = /[\?&]feature\.enableSharePointOnlineFile=true/i.test(getLocationHref());

    // Owner: yuanjieluo, 2022/11/08, kusto new button
    public static enableKustoNewButton: boolean = /[\?&]feature\.kustoNewBtn=true/i.test(getLocationHref());

    // Use this flag to hide the new LS button for data warehouse
    public static enableWarehouseNewButton: boolean = /[\?&]feature\.warehouseNewBtn=true/i.test(getLocationHref());

    // Owner: kaelinhoang, 2024/10/17, Enable ADF and Synapse template import into Trident
    public static migrateTemplate: boolean = getDPEFeatureFlag('migrateTemplate');

    //Owner: yuanjieluo, 2024/04/30
    public static enableWorkspaceIdentity: boolean = getDPEFeatureFlag('enableMSI');

    //Owner: yuanjieluo, 2024/12/30
    public static enableTeradataV2PCS: boolean = /[\?&]feature\.enableTeradataV2PCS=true/i.test(getLocationHref()) && !__IS_FABRIC_DPE__;

    //Owner: yuanjieluo, 2025/06/10
    public static enableTeradataBuiltIn: boolean = getDPEFeatureFlag('enableTeradataBuiltIn');

    // Owner: yaqiqiu, 2026/3/24
    public static enableSnowflakeBuiltinStorageIntegration: boolean = getDPEFeatureFlag('enableSFBuiltInStorage') ?? __IS_FABRIC_DPE__;

    //Owner: yuanjieluo, 2025/06/12
    public static disableProseMapping: boolean = !(/[\?&]feature\.disableProseMapping=false/i.test(getLocationHref()));

    //Owner: yuanjieluo, 2025/09/15
    public static parquetMapping: boolean = getDPEFeatureFlag('parquetMapping');

    //Owner: yuanjieluo, 2025/09/16
    public static teradataSinkInADF: boolean = /[\?&]feature\.teradataSinkInADF=true/i.test(getLocationHref());

    //Owner: yuanjieluo, 2025/11/04
    public static workspaceObjectIdFix: boolean = getDPEFeatureFlag('workspaceObjectIdFix');

    //Owner: yuanjieluo, 2025/11/06
    public static lakehouseUpsertPartition: boolean = getDPEFeatureFlag('lakehouseUpsertPartition') ?? __IS_FABRIC_DPE__;
    public static lakehouseUpsertPartitionInCopyJob: boolean = getDPEFeatureFlag('lakehouseUpsertPartitionInCopyJob') ?? __IS_FABRIC_DPE__;

    //Owner: yuanjieluo, 2025/11/18
    public static depWarning: boolean = /[\?&]feature\.depWarning=true/i.test(getLocationHref());

    //Owner: yuanjieluo, 2025/11/25
    public static dMTSInGetData: boolean = getDPEFeatureFlag('dMTSInGetData');

    //Owner: yuanjieluo, 2026/01/08
    public static timestampNtz: boolean = getDPEFeatureFlag('enableTimestampNtz') ?? true;

    //Owner: soumiksarkar, 2026/09/01
    public static pgSinkAutoCreate: boolean = getDPEFeatureFlag('pgSinkAutoCreate') && __IS_FABRIC_DPE__;

    public static cjAzurePGv2: boolean = getDPEFeatureFlag('CJAzurePGv2') ?? true;

    //Owner: yuanjieluo, 2026/02/26
    public static subFoldersMappingInCopyjob: boolean = getDPEFeatureFlag('subFoldersMappingInCopyjob') ?? true;

    //Owner: yuanjieluo, 2026/02/26
    public static dialogForSubFoldersMapping: boolean = getDPEFeatureFlag('dialogForSubFoldersMapping');

    //Owner: yuanjieluo, 2026/03/10
    public static fabricSqlED: boolean = getDPEFeatureFlag('fabricSqlED');

    // Owner: yuanjieluo, 2026/03/13
    public static supportDelta: boolean = getDPEFeatureFlag('olDelta') && __IS_FABRIC_DPE__;

    //Owner: wangzhan, 2026/08/17
    public static supportDeltaCloneCopyJob: boolean = getDPEFeatureFlag('supportDeltaCloneCopyJob') && __IS_FABRIC_DPE__;

    //Owner: yuanjieluo, 2026/04/28
    public static disableServerCertificate: boolean = getDPEFeatureFlag('disableServerCertificate') ?? __IS_FABRIC_DPE__;

    //Owner: yuanjieluo, 2026/05/12
    public static connectionPropertiesForSnowflake: boolean = getDPEFeatureFlag('connectionPropertiesForSnowflake');

    //Owner: yuanjieluo, 2026/05/12
    public static connectionPropertiesForSql: boolean = getDPEFeatureFlag('connectionPropertiesForSql');

    //Owner: yuanjieluo, 2026/05/12
    public static connectionPropertiesForPostgreSql: boolean = getDPEFeatureFlag('connectionPropertiesForPostgreSql');

    //Owner: yuanjieluo, 2026/05/12
    public static connectionPropertiesForMySql: boolean = getDPEFeatureFlag('connectionPropertiesForMySql');

    // TODO - Remove this flag post public preview
    public static enableAzureSqlNativeCdc: boolean = (/[\?&]feature\.enableAzureSqlNativeCdc=true/i.test(getLocationHref()));

    // Owner: kaixuanxu, 2022/10/26 - Http Interceptor for collect dependency informations
    public static enableLoggingInterceptor: boolean = /[\?&]feature\.enableLoggingInterceptor=true/i.test(getLocationHref());

    // Owner: kaixuanxu, 2023/05/15 - Enable SHIR usage
    public static enableSHIRQueryUsage = /[\?&]feature\.enableSHIRQueryUsage=true/i.test(getLocationHref());

    //Onwer: kaixuanxu, 2024/03/29 -Enable SSIS in Fabric
    public static enableSSISInFabric: boolean = /[\?&]feature\.enableSSISInFabric=true/i.test(getLocationHref());

    // Owner: kaixuanxu, 2026/05/21 - enable Lakehouse-only DMTS auth behavior in SSIS Get Data flow.
    public static enableSsisLakehouseOnlyDmtsAuth: boolean = getDPEFeatureFlag('ssisLhDmts') ?? false;

    //Onwer: kaixuanxu, 2024/07/09 -Show legacy connectors
    public static showLegacy: boolean = /[\?&]feature\.showLegacy=true/i.test(getLocationHref());
    // Owner: jenqiao, 04/18/25 - V1 connectors not using above ff
    public static hideLegacyBatch2: boolean = /[\?&]feature\.hideLegacyBatch2=true/i.test(getLocationHref());

    //Onwer: kaixuanxu, 2024/10/23 -enable SAP CDC copy
    public static enableSapCdcCopy: boolean = getDPEFeatureFlag('sapCdcCopy');

    // Owner: kaixuanxu, 2024/12/18 -support catalog for azure data bricks
    public static enableAzDatabricksCatalog: boolean = getDPEFeatureFlag('azdbkCatalog') ?? __IS_FABRIC_DPE__;

    // Owner: kaixuanxu, 2025/08/26 -   This ff is control the sap mirror to relase the datasphere first
    public static mirrorDatasphere1st: boolean = /[\?&]feature\.ds1st=true/i.test(getLocationHref());

    //Owner: ljosyula, 2026/07/02 -Snowflake mirror SI staging flight (prod: shell-forwarded bare feature.mirrorSFSI, driven by the REPSnowflakeEnableStorageIntegrationStaging flight).
    // Manual dev/test override for the SI page is via mirrorSFStorageIntegration below.
    public static mirrorSnowflakeStorageIntegrationStagingFlight: boolean = /[\?&]feature\.mirrorSFSI=true/i.test(getLocationHref());

    //Owner: ljosyula, 2026/06/11 -This ff controls the snowflake mirror storage integration staging step; enabled when EITHER the UX flag (mirrorSFStorageIntegration) OR the replicator flight (REPSnowflakeEnableStorageIntegrationStaging) is on
    public static mirrorSnowflakeStorageIntegration: boolean = (getDPEFeatureFlag('mirrorSFStorageIntegration') ?? false) || GlobalVariables.mirrorSnowflakeStorageIntegrationStagingFlight;

    //Owner: kaixuanxu, 2026/02/09 -This ff is control the snowflake mirror security roles sync
    public static snowflakeSecurityRoles: boolean = getDPEFeatureFlag('snowflakeSecurityRoles');
    // Owner: fangl, 2026/04/16 - Enable upload file in copy activity source
    public static enableUploadFile: boolean = getDPEFeatureFlag('uploadFile');

    // Owner: kaixuanxu, 2026/03/17 - enable PostgreSQL auto mode support via azure_cdc.get_publication_mode() UDF
    public static enablePgAutoMode: boolean = getDPEFeatureFlag('pgAutoMode') ?? /[\?&]feature\.pgAutoMode=true/i.test(getLocationHref());

    // Owner: fangl, 2026/04/21 - enable PostgreSQL identity config via azure_cdc.get_identity_config() UDF
    public static enablePgIdentityConfigUdf: boolean = getDPEFeatureFlag('pgIdentityConfigUdf') ?? false;

    public static skipKeyColumnsForAzPG: boolean = getDPEFeatureFlag('skipKeyColumnsForAzPG');

    // Owner: fangl, 2026/07/18 - Enable the native Azure HorizonDB connector (mirror + copy). The
    // HorizonDB backend is not yet ready, so this defaults off. When off, HorizonDB sources bind to
    // the existing AzurePostgreSQL connector to avoid breaking the shipping HorizonDB mirror.
    // The flag is forwarded from the di-extension shell as the `feature.azureHorizonDb` query param.
    public static enableAzureHorizonDb: boolean = /[\?&]feature\.azureHorizonDb=true/i.test(getLocationHref());

    // Enable on-premises PostgreSQL as a mirror source. The extension forwards the
    // MountedPostgreSqlOnPrem feature switch through feature.pgOP.
    public static mirrorPostgreSql: boolean = /[\?&]feature\.pgOP=true/i.test(getLocationHref());

    // Owner: fangl, 2026/07/29 - Enable the OneLake Files source connector (copy + copy job). Off by
    // default while the connector is stabilizing. Controlled from the di-extension shell via the
    // `feature.dpe.oneLakeFileConnector` (or `feature.dpe_madrid.oneLakeFileConnector`) flag.
    public static enableOneLakeFileConnector: boolean = getDPEFeatureFlag('oneLakeFileConnector') && __IS_FABRIC_DPE__;

    // Owner: daisyjin, 2026/09/03 - Enable the OneLake Files trigger in copy job.
    public static enableOneLakeFileTrigger: boolean = getDPEFeatureFlag('oneLakeFileTrigger');

    // Owner: kaixuanxu, 2025/05/12 -support gbq v2 versions
    public static enableGBQVersion: boolean = getDPEFeatureFlag('enableGBQVersion') ?? !__IS_FABRIC_DPE__;

    public static enableTableNameEscape: boolean = getDPEFeatureFlag('escapeAtInTableName') ?? __IS_FABRIC_DPE__;

    // Owner: yaqiqiu, 2023/07/05 - Mount Trident from ADF
    public static enableTridentMounting: boolean = !(/[\?&]feature\.enableTridentMounting=false/i.test(getLocationHref())) && isPublicCloudEnvironment();

    // Owner: yaqiqiu, 2026/01/12 - Copyjob support sub-folder
    public static copyJobSupportSubFolder: boolean = getDPEFeatureFlag('CJSubFolder') ?? __IS_FABRIC_DPE__;

    // Owner: yaqiqiu, 2026/08/11 - Copy job support multiple wildcard paths
    public static copyJobMultipleWildcardPaths: boolean = getDPEFeatureFlag('CJMWP') ?? __IS_FABRIC_DPE__;

    // Owner: yaqiqiu, 2026/09/04 - Copy job support Oracle NUMBER settings
    public static copyJobOracleNumberSettings: boolean = getDPEFeatureFlag('CJORCNS');

    // Owner: yaqiqiu, 2026/04/14 - support generic cdc for blob/gen2/S3/GCS/OCS/lakehouse
    public static copyJobGenericCdc: boolean = getDPEFeatureFlag('CJGCDC') ?? true;

    // Owner: yaqiqiu, 2026/04/23 - support custom database and schema for snowflake of readonly db
    public static snowflakeCDCSharedDbCopyJob: boolean = getDPEFeatureFlag('SSDB') ?? true;

    // Owner: yaqiqiu, 2026/05/12 - support generic cdc phase 2 w/ more file connectors
    public static copyJobGenericCdcPhase2: boolean = getDPEFeatureFlag('CJGCDC2');

    // Owner: yaqiqiu, 2026/05/29 - custom staging schema for CDC / SCD2 / Truncate
    public static copyJobCustomStagingSchema: boolean = getDPEFeatureFlag('CJCSS') ?? true;

    // Owner: yaqiqiu, 2026/07/20 - Copy Null records
    public static copyJobNullRecords: boolean = getDPEFeatureFlag('CJNULL') ?? true;

    // Owner: yaqiqiu, 2026/07/30 - Custom CDC capture instance per source table
    public static copyJobCustomCaptureInstance: boolean = getDPEFeatureFlag('CJCCI') ?? true;

    // Owner: yaqiqiu, 2026/07/27 - Enable Multiline rows in Copy Job
    public static enableMultiline: boolean = getDPEFeatureFlag('CJML') ?? true;

    // Owner: fangl, 2026/08/03 - Support mix of watermark and full copy (refreshWithoutIncrementalColumn) in a single incremental Copy Job
    public static copyJobRefreshWithoutIncrementalColumn: boolean = getDPEFeatureFlag('CJRWIC') ?? true;

    // Owner: daisyjin, 2026/02/25 - EventStream as source in Copy Job
    public static eventStreamSourceInCopyJob: boolean = /[\?&]feature\.CJESSource=true/i.test(getLocationHref());

    // Owner: daisyjin, 2026/02/25 - EventStream as sink in Copy Job
    public static eventStreamSinkInCopyJob: boolean = /[\?&]feature\.CJESSink=true/i.test(getLocationHref());

    public static enableOPDG: boolean = /[\?&]feature\.opdg=true/i.test(getLocationHref());

    public static opdgPhase2: boolean = /[\?&]feature\.opdgPhase2=true/i.test(getLocationHref());

    // Owner: anredd, 2025/01/16 - Enabling OPDG option for connections by external activities
    public static enableOPDGForActivities: boolean = /[\?&]feature\.opdgExternalActivities=true/i.test(getLocationHref());

    // Owner: wangzhan, 2026/4/10
    public static callerInQueryApi: boolean = getDPEFeatureFlag('qCaller');

    public static enableODataSAMI: boolean = /[\?&]feature\.ODataSAMI=true/i.test(getLocationHref());

    // Owner: yaqiqiu, 2024/02/08 - enable SPN in Snowflake V2
    public static enableSnowflakeV2SPN: boolean = /[\?&]feature\.enableSnowflakeV2SPN=true/i.test(getLocationHref());

    // Owner: jmcallister, 2021/07/26, only update last published commit id if ARM templates are generated and saved
    public static disableRelativeUTCTimezoneFormat: boolean = /[\?&]feature\.disableRelativeUTCTimezoneFormat=true/i.test(getLocationHref());

    // Owner: meiyl, 2023/11/2, support Evergreen version of SSIS
    public static enableEvergreenSsis: boolean = /[\?&]feature\.enableEvergreenSsis=true/i.test(getLocationHref());

    // Owner: dylanboliske
    public static enableCassandraDataFlow: boolean = /[\?&]feature\.enableCassandraDataFlow=true/i.test(getLocationHref());

    // Owner: anjshar
    public static enableGoogleCloudStorageSourceDataFlowWithFF: boolean = /[\?&]feature\.enableGoogleCloudStorageSourceDataFlow=true/i.test(getLocationHref());

    public static enableConnectorUserAuthCred: boolean = /[\?&]feature\.enableConnectorUserAuthCred=true/i.test(getLocationHref());

    public static enableAllConnectionParamForExternalActivities: boolean = /[\?&]feature\.eaConnectionParameterization=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;

    public static enableEnrichedOutputInNotebook: boolean = /[\?&]feature\.enrichedNbOutput=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;

    public static enableConnectionParamForAzBatch = /[\?&]connParamForAzBatch=true/i.test(getLocationHref());

    // Owner: kanikagupta
    public static enableEventHubsForApacheKafka: boolean = /[\?&]feature\.enableEventHubForApacheKafka=true/i.test(getLocationHref());
    public static enableEventHubsInCDC: boolean = /[\?&]feature\.enableEventHubsCDC=true/i.test(getLocationHref());
    public static enableKafkaAsLinkedService: boolean = /[\?&]feature\.enableKafkaCDC=true/i.test(getLocationHref());

    // Owner: dvachhani
    public static enableEventHubsInMDF: boolean = /[\?&]feature\.enableEventHubsMDF=true/i.test(getLocationHref());

    public static enableEventHubsPE: boolean = /[\?&]feature\.enableEventHubsPE=true/i.test(getLocationHref());

    public static get enableUserAuthCred(): boolean {
        return /[\?&]feature\.enableUserAuthCred=true/i.test(getLocationHref())
            || __IS_FABRIC_DPE__
            || this.enableConnectorUserAuthCred;
    }

    public static enableTrinoWithFF: boolean = /[\?&]feature\.enableTrino=true/i.test(getLocationHref());

    //Owner: vinaggarwal
    public static webhookMovePropertiesToAdvance: boolean = /[\?&]feature\.webhookMovePropertiesToAdvance=true/i.test(getLocationHref());

    // Owner: wentaoli, albertli 2021/11/04
    public static supportWasm = (() => {
        try {
            if (typeof WebAssembly === 'object'
                && typeof WebAssembly.instantiate === 'function') {
                const _testModule = new WebAssembly.Module(Uint8Array.of(0x0, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00));
                if (_testModule instanceof WebAssembly.Module) {
                    return new WebAssembly.Instance(_testModule) instanceof WebAssembly.Instance;
                }
            }
        } catch (e) {
        }
        return false;
    })();
    public static get enableExpressionBuilderV2(): boolean {
        return GlobalVariables.supportWasm && !GlobalVariables.isCmdApiApp &&
            !(/[\?&]feature\.enableExpBldrV2=false/i.test(getLocationHref()));
    }

    // Owner: t-qinweiyang, 2022/08/02, Dataflow Performance Improvement with Annotations
    public static _enableDataflowAnnotation: boolean = /[\?&]feature\.enableDfAnno=true/i.test(getLocationHref());
    public static get enableDataflowAnnotation(): boolean {
        return this._enableDataflowAnnotation;
    }

    // Owner: jmcallister, 2021/09/27, GitHub API rate limit improvement
    public static enableGitHubPerfImprovementFF: boolean = (/[\?&]feature\.enableGitHubPerfImprovement=true/i.test(getLocationHref()));

    public static supportPreserveDatetime: boolean = /[\?&]feature\.supportPreserveDatetime=true/i.test(getLocationHref());

    /**
     * This connector is for Deven Vachhani's POC
     * Owner: zoranliu, 2022/06/4
     */
    public static enableKafka: boolean = /[\?&]feature\.enableKafka=true/i.test(getLocationHref());

    // Owner: zoranliu, 2022/08/23
    public static enableMicrosoft365DataFlowWithFF: boolean = /[\?&]feature\.enableMicrosoft365DataFlow=true/i.test(getLocationHref());

    /**
     * Owner: zoranliu, 2022/09/08
     * @deprecated: Not in our plan now.
     */
    public static enableOracleDataFlowWithFF: boolean = /[\?&]feature\.enableOracleDataFlow=true/i.test(getLocationHref()) || isDevEnvironment();

    // Owner: zoranliu, 2023/04/14
    public static enableSAPODataWithFF: boolean = /[\?&]feature\.enableSAPOData=true/i.test(getLocationHref());

    // Owner: zoranliu, 2023/05/18
    public static enableCopySapOData: boolean = /[\?&]feature\.enableCopySapOData=true/i.test(getLocationHref());

    /**
     * Feature flag for Azure PostgreSQL, Azure Data Explorer, and Google Cloud Storage
     * Owner: zoranliu, 2025/01/07
     */
    public static copyJobConnectorsPhase2: boolean = getDPEFeatureFlag('copyJobConnectorsPhase2');
    public static copyJobAzureTableSink: boolean = getDPEFeatureFlag('cjAzTableSink');

    // Owner: kanikagupta, 2022/10/26
    public static enableAmazonRedshiftSink: boolean = getDPEFeatureFlag('enableAmazonRedshiftSink') && __IS_FABRIC_DPE__;

    // Owner: sanuragk, 2026/09/08
    public static enableBitbucketConnector: boolean = getDPEFeatureFlag('enableBitbucketConnector') && __IS_FABRIC_DPE__;

    // Owner: wsoylemez 2026/09/23
    public static enableOracleFusionConnector: boolean =
        getDPEFeatureFlag('enableOracleFusionConnector') && __IS_FABRIC_DPE__;

    // Owner: singhdevansh, 2026/09/10
    public static enableVivaInsightsConnector: boolean = getDPEFeatureFlag('VIC') && __IS_FABRIC_DPE__;

    // Owner: sanuragk, 2026/09/08
    public static enableAttioConnector: boolean =
        getDPEFeatureFlag('enableAttioConnector') === true && __IS_FABRIC_DPE__;

    // Owner: wangzhan, 2026/09/30
    public static enableGenericCDataConnector: boolean =
        getDPEFeatureFlag('enableGenericCDataConnector') === true && __IS_FABRIC_DPE__;

    // Owner: zoranliu, 2025/02/28
    public static enableCJBatchUpsert: boolean = getDPEFeatureFlag('enableCJBatchUpsert');

    public static bypassSnowflakeStagingUserAuth: boolean = getDPEFeatureFlag('bypassSFStagingUserAuth');

    // Owner: zoranliu, 2025/05/23
    public static copyJobIncrementalCopyPhase2: boolean = getDPEFeatureFlag('copyJobIncrementalCopyPhase2');

    // Owner: zoranliu, 2026/05/27
    public static copyJobMultipleIncrementalColumnsForSAPTable: boolean = getDPEFeatureFlag('CJMICST') ?? true;

    // Owner: zoranliu, 2026/05/20
    public static copyJobCDFDetection: boolean = getDPEFeatureFlag('CJCDFD') ?? true;

    // Owner: fangl, 2026/06/07 - Enable query mode for SAP Table connector in copy job.
    public static copyJobSAPTableQueryMode: boolean = getDPEFeatureFlag('CJSTQM');

    // Owner: zoranliu, 2026/04/30
    public static copyJobOracleCDCSink: boolean = /[\?&]feature\.CJORCCDCS=true/i.test(getLocationHref());

    // Owner: fangl, 2026/08/26 - Enable copy job source partition for the Google BigQuery connector.
    public static copyJobBigQuerySourcePartition: boolean = getDPEFeatureFlag('CJBQSP');

    // Owner: zoranliu, 2026/06/01
    public static copyJobSnowflakeSCD2: boolean = getDPEFeatureFlag('CJSFSCD2') ?? true;

    // Owner: fangl, 2026/04/23 - support clone lakehouse delta table as binary
    public static cloneLHTable: boolean = getDPEFeatureFlag('cloneLHTable');

    // Owner: fangl, 2026/05/10 - Copyjob support shared compute (bulk copy)
    public static copyJobUseSharedCompute: boolean = getDPEFeatureFlag('CJUSC');

    // Owner: daisyjin, 2026/05/27 - Copyjob delta table trigger (run on lakehouse table change)
    public static copyJobDeltaTableTrigger: boolean = getDPEFeatureFlag('CJDTT') ?? true;

    // Owner: fangl, 2026/08/24 - Copyjob support Azure Data Explorer KQL function as source
    public static copyJobKustoFunction: boolean = getDPEFeatureFlag('CJKQLFUNC');

    public static enableSsisIrSharingWithFF = /[\?&]feature\.enableSsisSharing=true/i.test(getLocationHref());

    // Owner: kalyanke, 2021/12/02
    public static enableWebHookOnIR: boolean = /[\?&]feature\.enableWebHookOnIR=true/i.test(getLocationHref());

    // Owner: kalyanke, 2023/06/16
    public static enablePollingFeature: boolean = /[\?&]feature\.polling=true/i.test(getLocationHref());

    // Owner: raprade, 2022/03/31, for viewing expression builder poc
    public static expressionBuilderPOC: boolean = /[\?&]feature\.expressionBuilderPOC=true/i.test(getLocationHref());

    //Owner: anjshar, 2023/01/26, for custom properties option at IR level
    public static enableDataFlowCustomConfigurationFromIR: boolean = /[\?&]feature\.enableADFDataFlowCustomConfigurationFromIR=true/i.test(getLocationHref());

    //Owner: shnaray, 2023/04/19, for removing compute type option at IR level
    public static removeComputeTypeFromIR: boolean = /[\?&]feature\.ADFDataflowRemoveComputeTypeFromIR=true/i.test(getLocationHref());

    // Owner: amberz/nramanathan, 2024/04/10
    public static enableAzureDatabricksJobActivity: boolean = !(/[\?&]feature\.adbJobActivity=false/i.test(getLocationHref()));

    // Owner: chenglongz, 2024/08/30
    public static enableAzureDatabricksADFJobActivity: boolean = (/[\?&]feature\.adbADFJobActivity=true/i.test(getLocationHref()));

    // Owner: mablumen, 2023/04/25
    public static enableDatabricksActivity: boolean = (/[\?&]feature\.dbActivity=true/i.test(getLocationHref()));

    public static enableHDInsightActivity: boolean = (/[\?&]feature\.hdiActivity=true/i.test(getLocationHref()));

    public static showSynapseItemWarning: boolean = true;

    // Owner: dfandel, 2024/01/03
    public static enableRedirectDisable: boolean = (/[\?&]feature\.redirectdisable=true/i.test(getLocationHref()));

    // Owner: yathin, 2026/07/10 - Web activity response JSON path field
    public static enableWebActivityJsonPath: boolean = getDPEFeatureFlag('webActivityJsonPath');

    // Owner: kaelinhoang, 2025/01/30
    public static enableSemanticModelRefreshTour: boolean = getDPEFeatureFlag('enableSemanticModelRefreshTour');

    // Owner: kaelinhoang, 2025/05/28
    public static templateFilter: boolean = getDPEFeatureFlag('templateFilter') ?? __IS_FABRIC_DPE__;

    // Owner: kaelinhoang, 2026/08/11 - Keeps the "Data Factory (Classic)" naming. The FDF cosmetic changes stay
    // under `feature.fdf`; this flag layers the classic strings on top and enables those cosmetics as well.
    public static classicRebranding: boolean = (/[\?&]feature\.fdfClassic=true/i.test(getLocationHref())) && !__IS_A365__;

    // Owner: dfandel, 2025/11/04
    public static enableScopeMixedMode: boolean = /[\?&]feature\.enableScopeMixedMode=true/i.test(getLocationHref());

    // Owner: altra, 2025/11/21
    public static itemConnectionRefWVL: boolean = getDPEFeatureFlag('itemConnectionRefWVL');

    // Owner: akshaybist, 2026/02/16, internal testing flag to bypass restrictions during MDF dataflow migration
    public static enableMdfMigrationDebug: boolean = (getDPEFeatureFlag('mdfMigrationDebug') ?? false) && ['MSIT', 'DAILY', 'DXT'].includes(ShellGlobalVariables.fabricEnv);

    public static showFloatingToolbar: boolean = /[\?&]feature\.showFloatingToolbar=true/i.test(getLocationHref());

    public static hideSaveButton: boolean = /[\?&]feature\.hideSaveButton=true/i.test(getLocationHref());

    public static showFabricConnector: boolean = /[\?&]feature\.showFabricConnector=true/i.test(getLocationHref());

    public static extendedMountedDF: boolean = __IS_FABRIC_ADF__ && (getDPEFeatureFlag('extendedMountedDF') ?? true);

    public static isOpenedFromFabricProvisioning: boolean = getDPEFeatureFlag('fabricOnboardingSource') ?? false;

    // New-look Compatibility assessment experience for Synapse (isa365).
    public static extendedSynapseMigration: boolean = __IS_A365__ && (getDPEFeatureFlag('extendedSynapseMigration') ?? true);

    /**
     * Combined gate for the new-look Compatibility assessment experience.
     * Enabled for Fabric mounted ADF (extendedMountedDF) and Synapse (extendedSynapseMigration).
     */
    public static get isNewMigrationAssessmentEnabled(): boolean {
        return GlobalVariables.extendedMountedDF || GlobalVariables.extendedSynapseMigration;
    }

    public static enableMountDfTenantConfiguration: boolean = /[\?&]feature\.ctInAdf=true/i.test(getLocationHref());

    // -----------------------------------------------------------------------------------------
    // ------ Begin private static section for global variables only used in get operations
    // ------   All variables in this section should have a leading _ in the name
    // -----------------------------------------------------------------------------------------
    private static _enableMountMigration: boolean = getDPEFeatureFlag('mountMigration');

    // Owner: jmcallister, 2021/04/22, support bring your own GitHub OAuth app for government cloud
    private static _enableGitHubBYOA: boolean = /[\?&]feature\.enableGitHubBYOA=true/i.test(getLocationHref());

    // Owner: vekandib, 2022/09/09, show factory environment label next to factory-name
    private static _enableFactoryEnvironment: boolean = /[\?&]feature\.displayEnvironment=true/i.test(getLocationHref());

    // Owner: anredd, 2021/05/24, allow for internal cx to bypass df function validation
    private static _enableDataFlowFunctionValidationBypass: boolean = (/[\?&]feature\.ignoreDataFlowFuncValidation=true/i.test(getLocationHref()));

    private static _enablePutWorkspaceFromUrl: boolean = /[\?&]feature\.putWS=true/i.test(getLocationHref());

    private static _enableSparkGateway: boolean = /[\?&]feature.sparkGateway=true/i.test(getLocationHref());

    private static _disableCustomEventsTrigger: boolean = /[\?&]feature\.disableCustomEventsTrigger=true/i.test(getLocationHref());

    // Owner: sekrantz, 2021/07/21, allow ETL Artifact feature
    private static _enableEtlArtifact: boolean = (/[\?&]feature\.enableEtlArtifact=true/i.test(getLocationHref()));

    // Owner: amja, 2021/11/10, allow importing mapping data from excel for etl map data feature
    private static _enableExcelImportForMapData = (/[\?&]feature\.enableExcelImportForMapData=true/i.test(getLocationHref()));

    // Owner: amja, 2022/06/30, allow apply rules to transform source schema for etl map data feature
    private static _enableRulesToTransformForMapData = (/[\?&]feature\.enableRulesToTransformForMapData=true/i.test(getLocationHref()));

    // Owner: siddsingh, 2022/05/26, allow displaying line chart for data flow run history
    private static _enableDataflowRunHistoryChart = (/[\?&]feature\.enableDataflowRunHistoryChart=true/i.test(getLocationHref()));

    // Owner: jmcallister, 2021/10/05, GitHub API limit improvement batch size
    private static _gitHubBatchSize: boolean = (/[\?&]feature\.gitHubBatchSize=[1-9][0-9]*/i.test(getLocationHref()));

    // Owner: anredd, 2022/01/25
    private static _enableNewClusterAttributes: boolean = /[\?&]feature\.enableNewClusterAttributes=true/i.test(getLocationHref());

    // Owner: soro, 2022/03/09
    private static _lakeDB2021Api: boolean = ShellGlobalVariables.useLakeDB2021Api;

    // Owner: sekrantz. 2022/08/02
    private static _enableDataFirstCanvas: boolean = /[\?&]feature\.enableDataFirstCanvas=true/i.test(getLocationHref());

    // Owner: anredd, 2022/08/09
    private static _enableNestedActivityStatusIcons: boolean = /[\?&]feature\.enableNestedActivityStatusIcons=true/i.test(getLocationHref());

    // Owner: anredd, 2022/08/16
    private static _enableDynamicContentFlyout: boolean = /[\?&]feature\.enableDynamicContentFlyout=true/i.test(getLocationHref());

    // Owner: anredd, 2023/01/23
    private static _enableDynamicContentEditor: boolean = /[\?&]feature\.draftEditor=true/i.test(getLocationHref());

    // Owner: anredd, 2024/04/11
    private static _enableDraftEditorPreCopyScript: boolean = /[\?&]feature\.draftEditorPreCopyScript=true/i.test(getLocationHref());

    // Owner: anredd, 2023/10/23
    private static _fabricValidate: boolean = /[\?&]feature\.fabricValidate=true/i.test(getLocationHref());

    // Owner: anredd, 2024/01/08
    private static _enableActivityOutputInference: boolean = /[\?&]feature\.actInf=true/.test(getLocationHref());

    // Owner: anredd, 2025/07/01
    private static _enableExpressionEvaluation: boolean = getDPEFeatureFlag('expressionEvaluation') ?? false;

    // Owner: anredd, 2025/08/19
    private static _enableLakehouseMaintenanceActivity: boolean = /[\?&]feature\.lhAct=true/.test(getLocationHref());

    // Owner: kalyanke, 2025/08/19
    private static _enableRefreshSqlEndpointActivity: boolean = /[\?&]feature\.sqlEndPtAct=true/.test(getLocationHref());

    // Owner: anredd, 2025/10/06
    private static _enableRefreshMaterializedLakeViewActivity: boolean = /[\?&]feature\.rmlvAct=true/.test(getLocationHref());

    private static _enable5by5Flag: boolean = /[\?&]feature\.5by5=true/i.test(getLocationHref());

    // Owner: raprade. 2022/07/15
    public static enableMultiJoin: boolean = /[\?&]feature\.multijoin=true/i.test(getLocationHref());

    public static showTealTheme: boolean = /[\?&]feature\.showTeal=true/i.test(getLocationHref()) || isDevEnvironment();

    public static enableExtensibleActivity: boolean = (/[\?&]feature\.extensibleActivity=true/i.test(getLocationHref()));
    public static enableEmailActivityWithFF: boolean = (/[\?&]feature\.emailActivity=true/i.test(getLocationHref())) || GlobalVariables.enableExtensibleActivity;
    public static enableTeamsActivityWithFF: boolean = (/[\?&]feature\.teamsActivity=true/i.test(getLocationHref())) || GlobalVariables.enableExtensibleActivity;
    public static enableLegacyTeamsOutlookDeprecationNotice: boolean = /[\?&]feature\.teamsoutlookdep=true/i.test(getLocationHref());
    public static hideLegacyTeamsOutlookActivities: boolean = /[\?&]feature\.hideLegacyTeamsOutlook=true/i.test(getLocationHref());
    // Owner: daisyjin, 2023/06/06, this feature flag controls Azure Blob Storage, Invoke ADF pipeline, and Azure DevOps activities
    public static enableMoreActivities: boolean = (/[\?&]feature\.moreActivities=true/i.test(getLocationHref())) || GlobalVariables.enableExtensibleActivity;

    // Owner: daisyjin, 2023/07/28
    public static enableDevOpsActivity: boolean = (/[\?&]feature\.devopsActivity=true/i.test(getLocationHref())) || GlobalVariables.enableExtensibleActivity;
    public static enableLogActivity: boolean = (/[\?&]feature\.logActivity=true/i.test(getLocationHref())) || GlobalVariables.enableExtensibleActivity;

    // Owner: yangxin, 2024/02/28
    public static mirrorUAMI: boolean = /[\?&]feature\.mirrorUAMI=true/i.test(getLocationHref());
    // Owner: kaixuanxu, 2025/07/08 UAMI SUPPORT FOR MIRROR
    public static mirrorUAMI4Sql2025: boolean = getDPEFeatureFlag('mirrorUAMI4Sql2025');
    public static mirrorUAMI4SqlMI: boolean = getDPEFeatureFlag('mirrorUAMI4SqlMI');
    //Owner: kaixuanxu: 2025/10/27 New eligible table query for sql mi
    public static mirrorNewEligibleQueryForSQLMI: boolean = (/[\?&]feature\.nQ4SQLMI=true/i.test(getLocationHref()));

    // Owner: yangxin, 2024/04/10
    public static mirrorOPDGAllSources: boolean = getDPEFeatureFlag('mirrorOPDG');
    public static mirrorWICosmos: boolean = getDPEFeatureFlag('mirrorWICosmos') ?? true;
    //owner: mnick, 2025/08/24
    public static mirrorGBQOPDG: boolean = /[\?&]GBQOPDG=true/i.test(getLocationHref());
    // Owner: daisyjin, 2025/12/30
    public static mirrorGBQProjectID: boolean = getDPEFeatureFlag('GBQProjectID');
    // Owner: daisyjin, 2026/01/22
    public static mirrorGBQTreeView: boolean = getDPEFeatureFlag('GBQTreeView') ?? true;
    //Owner: wsoylemez, 2026/08/17
    public static mirrorGBQSecurityRoles: boolean = getDPEFeatureFlag('GBQSecurityRoles');
    //owner: mnick, 2025/10/13
    public static twtParam: boolean = /[\?&]twtParam=true/i.test(getLocationHref());
    //owner: kaixuanxu,2025/02/18- hook fs for OPDG/VNET FOR AZUER PG SQL
    public static mirrorOPDGAzPgSql: boolean = /[\?&]feature\.mirrorOPDGAzPgSql=true/i.test(getLocationHref());
    // Owner: yuanjieluo, 2024/08/05
    public static mirrorCloudSqlServer: boolean = getDPEFeatureFlag('mirrorCloudSqlServer');
    // Owner: yangxin, 2024/07/24
    public static mirrorBackBtnOnTop: boolean = getDPEFeatureFlag('mirrorBackBtnOnTop');
    // Owner: yangxin, 2024/05/08
    public static repDisableReplicationLimit: boolean = /[\?&]feature\.disRepLim=true/i.test(getLocationHref());
    public static mirrorSQLExtraTypes = getDPEFeatureFlag('mirrorSQLExtraTypes');
    // Owner: fangl, 2026/04/16 - BE kill switch to disable parallel batch fetching for table extended info.
    public static disableMirrorParallelTableValidation: boolean = /[\?&]feature\.disMirrorPTV=true/i.test(getLocationHref());
    public static mirrorParallelTableValidation: boolean =
        !GlobalVariables.disableMirrorParallelTableValidation && (getDPEFeatureFlag('mirrorParallelTableValidation') ?? true);
    // Owner: fangl, 2026/04/16 - Customize concurrency level for parallel table validation. Only effective when mirrorParallelTableValidation is enabled. Default 2, max 5.
    // Read as a numeric URL flag (feature.dpe.mirrorPTVConcurrency=<n>).
    // getDPEFeatureFlag() only returns boolean, so it cannot carry a numeric value; parse the URL directly instead.
    public static mirrorParallelTableValidationConcurrency: number = (() => {
        const match = /[?&]feature\.dpe\.mirrorPTVConcurrency=(\d+)/i.exec(getLocationHref());
        const parsed = match ? Number(match[1]) : NaN;
        return Math.max(1, Math.min(5, Number.isFinite(parsed) && parsed > 0 ? parsed : 2));
    })();
    // Owner: kaixuanxu, 2026/04/24 - Move Snowflake database selection inline on the configure-mounting page
    public static snowflakeInlineDbSelection: boolean = getDPEFeatureFlag('snowflakeInlineDb');

    // Owner jocy 2025/11/3
    public static enableCopyJobCopilot = __IS_FABRIC_DPE__ && getDPEFeatureFlag('copyJobCopilot');

    // Owner: kaelinhoang, 2023/12/04
    public static enableLargeActivityLimit: boolean = ShellGlobalVariables.enableLargeActivityLimit;
    public static enableFabricMigrationTool: boolean = !(/[\?&]feature\.fabricMigration=false/i.test(getLocationHref()));
    public static disbleFabricMigrationTool: boolean = (/[\?&]feature\.fabricMigration=false/i.test(getLocationHref()));
    public static enableSinglePipelineMigration: boolean = __IS_FABRIC_ADF__ && getDPEFeatureFlag('singlePipeline');

    // Owner: daisyjin, 2024/11/14, removed on ADLS SS right now its only valid on ADLA for Fabric
    public static enableWIAuthForAdlaAndAdls: boolean = /[\?&]WIAuthForAdlaAndAdls=true/i.test(getLocationHref());

    private static _enableThemeSetting: boolean = /[\?&]feature\.enableThemeSetting=true/i.test(getLocationHref());

    // Owner: chuluda, 2023/04/10, using this flag for controllign ADF git autosave
    private static _enableADFGitAutoSave: boolean = !(/[\?&]feature\.enableADFGitAutoSave=false/i.test(getLocationHref()));

    // Owner: altra, 2023/05/16
    private static _enableCallout: boolean = (/[\?&]feature\.enableCallout=true/i.test(getLocationHref()));

    // Owner: chuluda, 2023/06/15, using this flag for ADF Git AutoSave in livemode
    private static _enableAutoSaveLiveMode: boolean = !(/[\?&]feature\.enableAutoSaveLiveMode=false/i.test(getLocationHref()));

    // Owner: sekrantz, 2023/06/28
    private static _enableSimplifiedMonitoringColumns: boolean = (/[\?&]feature\.simplifiedMonitorColumns=true/i.test(getLocationHref()));

    // Owner: altra, 2023/11/29
    private static _enableSecureStringGlobalParameter: boolean = (/[\?&]feature\.secureStringGP=true/i.test(getLocationHref()));

    // Owner: zoranliu, 2022/11/10
    private static enableTridentNewTranslationLayer: boolean = /[\?&]feature\.newTransLayer=true/i.test(getLocationHref());

    // Owner: vekandib, 2024/04/24
    private static _enableOrderedArmTemplateGeneration: boolean = /[\?&]feature\.enableResourceOrdering=true/i.test(getLocationHref());

    // Owner: vekandib, 2024/05/06
    private static _enableMsiAuthForScopeActivity: boolean = !(/[\?&]feature\.msiAuthInScopeActivity=false/i.test(getLocationHref()));

    // Owner: vekandib, 2024/05/17
    private static _enableUamiAuthForScopeActivity: boolean = !(/[\?&]feature\.uamiAuthInScopeActivity=false/i.test(getLocationHref()));

    // Owner: vekandib, 2024/07/23
    private static _enableSpnAuthInAzFuncActivity: boolean = !(/[\?&]feature\.spnAuthInAzFuncActivity=false/i.test(getLocationHref()));

    // Owner: vekandib, 2026/01/16
    private static _useGitInitializeImprove: boolean = /[\?&]feature\.improveGitInitialze=true/i.test(getLocationHref());

    // Owner: anredd, 2025/02/03
    private static _enableUamiAuthForAzFuncActivity: boolean = (/[\?&]feature\.uamiAuthInAzFuncActivity=true/i.test(getLocationHref()));

    // Owner: akv, 2024/05/27
    public static _enableGen1MIAuthForMDF: boolean = /[\?&]feature\.gen1MiAuthInMDF=true/i.test(getLocationHref());

    // -----------------------------------------------------------------------------------------
    // ------ Begin "public static get" section for global variables that are based on multiple conditions
    // -----------------------------------------------------------------------------------------

    public static get isGAFactory(): boolean {
        return GlobalVariables.dataFactoryVersion === DATAFACTORY_GA_2018_06_01;
    }

    public static get showKustoConnector(): boolean {
        return /[\?&]feature\.kusto=true/i.test(getLocationHref());
    }

    // jenqiao 5/22, a copy in shell
    public static get strictParamValidation(): boolean {
        return ShellGlobalVariables.strictParamValidation;
    }
    public static get serviceNowParamedLs(): boolean {
        return ShellGlobalVariables.serviceNowParamedLs;
    }

    public static get containerValidation(): boolean {
        return /[\?&]feature\.enableContainerValidation=true/i.test(getLocationHref()) || GlobalVariables.isMicrosoftInternal;
    }

    // wenfluo: this flag is for scope pools on monitoring
    public static get enableScopePoolsOnMonitoring(): boolean {
        return /[\?&]feature\.enableScopePoolsOnMonitoring=true/i.test(getLocationHref());
    }

    // Owner: wenfluo, 2021/05/06. ONLY for automation tests.
    // Both the current automation tests subscriptions support or will support Scope on Synapse, use this flag to test sos-unenabled scenarios in UI.
    public static get enableScopeOnSynapseForAutoTest(): boolean | undefined {
        const href = getLocationHref();
        for (const trueOrFalse of [true, false]) {
            const regex = new RegExp(`[\?&]feature\.scopeOnSynapseForAutoTest=${trueOrFalse}`, 'i');
            if (regex.test(href)) {
                return trueOrFalse;
            }
        }
        return undefined;
    }

    public static get enableGitHubBYOA(): boolean {
        return this._enableGitHubBYOA || ((isFairfaxEnvironment() || isMooncakeEnvironment() || isBleuEnvironment() || isDelosEnvironment()));
    }

    public static get enableFactoryEnvironment(): boolean {
        return this._enableFactoryEnvironment || GlobalVariables.isMicrosoftInternal;
    }

    // Do not show policy UI if not ADF
    public static get enablePolicyValidation(): boolean {
        return !__IS_A365__;
    }

    public static get gitHubBatchSize(): number {
        return this._gitHubBatchSize ? +(new URLSearchParams(window.location.search).get('feature.gitHubBatchSize')) : GitHubConstants.GITHUB_GRAPHQL_FILES_BATCH_SIZE;
    }

    public static get enableEcoTokenInScopeActivity(): boolean {
        return /[\?&]feature\.enableEcoTokenInScopeActivity=true/i.test(getLocationHref());
    }

    public static get isPostGAFactory(): boolean {
        return GlobalVariables.dataFactoryVersion === DATAFACTORY_GA_2018_06_01 || GlobalVariables.dataFactoryVersion === DATAFACTORY_DATAFLOW;
    }

    public static get enableFlowletsDev(): boolean {
        // for flowlet features available in ci for testing, but are not to be included in initial release
        return isDevEnvironment() || isCIEnvironment();
    }

    public static get powerQueryConversion(): boolean {
        return GlobalVariables.enablePQConversion && !__IS_A365__;
    }

    public static get powerQueryPartitionByFileName(): boolean {
        return GlobalVariables.enablePQPartitionByFileName;
    }

    public static get enablepowerquery(): boolean {
        return !__IS_A365__ || this.powerquery;
    }

    public static get enableADFDataMapper(): boolean {
        return !__IS_A365__ && this.enableDataMapperinADF;
    }

    public static get isDataflowHistoryMonitoringEnabled(): boolean {
        return !__IS_A365__ && this._enableDataflowRunHistoryChart;
    }

    public static get powerQueryActivity(): boolean {
        return !__IS_A365__ || this.enablepowerQueryActivity;
    }

    public static get enableGlobalParameters(): boolean {
        return !__IS_A365__ && !GlobalVariables.enableIFrameMode || __IS_FABRIC_ADF__;
    }

    public static get enableDataFlowVersion(): boolean {
        return GlobalVariables.enableDataFlowVersionFlag && !__IS_A365__ && (!GlobalVariables.enableIFrameMode || (__IS_FABRIC_ADF__ && GlobalVariables.extendedMountedDF));
    }

    public static get isBabylonIntegrationEnabled(): boolean {
        return (isPublicCloudEnvironment() || isAdfFairfaxEnvironment() || isAdfMooncakeEnvironment() || /[\?&]feature\.purviewIntegration=true/i.test(getLocationHref()))
            && !isAdfBleuEnvironment()
            && !isAdfDelosEnvironment()
            && !/[\?&]feature\.purviewIntegration=false/i.test(getLocationHref())
            && (!__IS_FABRIC_ADF__ || (getDPEFeatureFlag('enablePurviewInMountdf') ?? false))
            && !__IS_FABRIC_DPE__;
    }

    public static get enableGlobalParametersImport(): boolean {
        return GlobalVariables.globalParametersImport;
    }

    public static get enablePreventDataExfiltration(): boolean {
        return !__IS_A365__ && (ShellGlobalVariables.enablePreventDataExfiltration || isDevEnvironment() || isCIEnvironment());
    }

    public static get dataFlowExtraFeatures(): boolean {
        return GlobalVariables.dataflowFeature;
    }

    public static get splitScriptEnabled(): boolean {
        return GlobalVariables.dataflowSplitScript;
    }

    public static isSupportedFactoryVersion(supportedVersion: string = GlobalVariables.dataFactoryVersion): boolean {
        return DATAFACTORY_API_VERSIONS.includes(supportedVersion);
    }

    public static isGitHubBlockedOnFactoryVersion(supportedVersion: string): boolean {
        return supportedVersion === DATAFACTORY_PREVIEW_2017_09_01;
    }

    public static get redirectMicrosoftTenant(): boolean {
        return GlobalVariables.redirectMicrosoft;
    }

    public static get enableCustomEventsTrigger(): boolean {
        return GlobalVariables.isPostGAFactory && !GlobalVariables._disableCustomEventsTrigger;
    }

    public static get enableTWTWindowValidation(): boolean {
        return GlobalVariables.twtWindowValidation;
    }

    public static get enableUndoFeature(): boolean {
        return this.enableUndo;
    }

    public static get enableBAGNpsSurvey(): boolean {
        if (GlobalVariables.bagNpsTesting) {
            return true;
        }
        if (__IS_A365__) {
            return false;
        }
        if (GlobalVariables.bagNpsSurveyFeatureOffFlag == null) {
            return GlobalVariables.bagNpsSurveyDefaultValue;
        }
        return !GlobalVariables.bagNpsSurveyFeatureOffFlag;
    }

    public static get authorPerfImprove(): boolean {
        return GlobalVariables.authorPerfImproveFlag || GlobalVariables.isMicrosoftInternal;
    }

    public static get enableDataFlowFunctionValidationBypass(): boolean {
        return this._enableDataFlowFunctionValidationBypass && (isDevEnvironment() || isCIEnvironment()) && GlobalVariables.isMicrosoftInternal;
    }

    public static get isSOCPreviewFeaturesEnabled(): boolean {
        return __IS_A365__ && GlobalVariables.enableSocPreviewFeatures === true;
    }

    public static get isADLSGen1ExplorerEnabled(): boolean {
        return __IS_A365__ && (this.isMicrosoftInternal || this.enableExploreGen1);
    }

    public static get getEnforcedAppId(): string {
        if (__IS_A365__ && GlobalVariables.enableNewSparkGraph === true && (isDevEnvironment() || isCIEnvironment())) {
            if (this.enforcedAppId) {
                return this.enforcedAppId[1];
            }
        }
        return null;
    }

    public static get isSamiSupportEnabled(): boolean {
        return this.enableSamiSupport;
    }

    public static get isMsiBackfillEnabled(): boolean {
        return (!__IS_A365__ && /[\?&]feature\.enableMSIBackfill=true/i.test(getLocationHref()));
    }

    public static get enableNewErrorMessage(): boolean {
        return !__IS_A365__ && (!this.enableIFrameMode || __IS_FABRIC_DPE__);
    }

    public static get allowImportDataFlowMonitoring(): boolean {
        return this.isMicrosoftInternal && this.enableDataFlowMonitorImport;
    }

    public static get isPutWorkspaceEnabled(): boolean {
        return this._enablePutWorkspaceFromUrl;
    }

    public static get productionOrigin(): string {
        return __IS_A365__ ? WORKSPACE_PROD_ORIGIN : PRODUCTION_ORIGIN;
    }

    public static get microsoftOrigin(): string {
        return __IS_A365__ ? WORKSPACE_MICROSOFT_PROD_ORIGIN : MICROSOFT_PRODUCTION_ORIGIN;
    }

    public static get isFromPrivateLink(): boolean {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (window as any).__isFromPrivateLink;
    }

    public static get isSparkGatewayEnabled(): boolean {
        return __IS_A365__ || this._enableSparkGateway;
    }

    public static get enableRenamingFromRightClick(): boolean {
        return !__IS_A365__ || this.enableA365Renaming;
    }

    public static get enablePerformanceTuning(): boolean {
        return GlobalVariables.allowPerformanceTuning && this.isMicrosoftInternal;
    }

    public static get isEtlArtifactEnabled(): boolean {
        return this._enableEtlArtifact;
    }

    public static get isExcelImportForMapDataEnabled(): boolean {
        return this._enableExcelImportForMapData;
    }

    public static get isRulesToTransformForMapDataEnabled(): boolean {
        return this._enableRulesToTransformForMapData;
    }

    public static get isDataflowRunHistoryChartEnabled(): boolean {
        return this._enableDataflowRunHistoryChart;
    }

    public static get enableNewClusterAttributes(): boolean {
        return this._enableNewClusterAttributes || isDevEnvironment() || isCIEnvironment() || __IS_FABRIC_DPE__;
    }

    // Keep this. Based on weko, currently there are some known issues in backend side that can affect Spark UI in some corner cases
    public static get enableStandaloneHs(): boolean {
        return !(/[\?&]feature\.enableStandaloneHS=false/i.test(getLocationHref()));
    }

    public static msInternalTenants: string[] =
        [
            MICROSOFT_TENANT_ID,
            MSAZURECLOUD_TENANT_ID,
            MSTORUS_TENANT_ID,
            PME_TENANT_ID,
            GME_TENANT_ID
        ];

    public static get enableAutosave(): boolean {
        // Owner: lilijing, 2021/11/11, autosave
        if (!__IS_A365__) {
            return false;
        }
        const isSetToTrue: boolean = (/[\?&]feature\.autosave=true/i.test(getLocationHref()));
        const isSetToFalse: boolean = (/[\?&]feature\.autosave=false/i.test(getLocationHref()));
        return isSetToTrue || (this.isMicrosoftInternal && !isSetToFalse);
    }

    /**
     * If autosave feature is not enabled, return false; otehrwise, check whether the resource type is supported or not
     */
    public static isAutosaveSupportType(resourceType: ResourceType): boolean {
        return GlobalVariables.enableAutosave && autosaveEnabledTypes.includes(resourceType);
    }

    public static get useLakeDB2021Api(): boolean {
        return this._lakeDB2021Api;
    }

    public static get enable5by5(): boolean {
        return this._enable5by5Flag || (localStorageGet(LOCAL_STORAGE_ENABLE_DATA_FIRST) === 'true');
    }

    public static get simplifyMonitoring(): boolean {
        return this.enable5by5 || this.simplifyMonitoringFlag;
    }

    // Owner: mablumen. 2022/08/11
    public static get enableLazyLoadingForDebug(): boolean {
        return this.lazyLoadingForDebugFlag;
    }

    public static get enablePipelineBilling(): boolean {
        return !__IS_A365__ && (!GlobalVariables.enableIFrameMode || (__IS_FABRIC_ADF__ && GlobalVariables.extendedMountedDF));
    }

    public static get enableMountMigration(): boolean {
        return this._enableMountMigration ?? !__IS_A365__;
    }

    // ******** PREVIEW UPDATE FEATURES ******** /

    // Owner: sekrantz. 2022/08/02
    public static get enableDataFirstCanvas(): boolean {
        return this._enableDataFirstCanvas || this.enable5by5;
    }

    // Owner: anredd. 2022/08/09
    public static get enableNestedActivityStatusIcons(): boolean {
        return this._enableNestedActivityStatusIcons;
    }

    // Owner: anredd, 2022/08/16
    public static get enableDynamicContentFlyout(): boolean {
        return this._enableDynamicContentFlyout || this.enable5by5;
    }

    // Owner: anredd, 2023/01/23
    public static get enableDynamicContentEditor(): boolean {
        return this._enableDynamicContentEditor && (this.enable5by5 || __IS_FABRIC_DPE__);
    }

    // Owner: anredd, 2024/04/11
    public static get enableDraftEditor_PreCopyScript(): boolean {
        return this._enableDraftEditorPreCopyScript && (this.enable5by5 || __IS_FABRIC_DPE__);
    }

    // Owner: anredd, 2024/01/08
    public static get enableActivityOutputInference(): boolean {
        return this._enableActivityOutputInference;
    }

    // Owner: anredd, 2025/07/01
    public static get enableExpressionEvaluation(): boolean {
        return this._enableExpressionEvaluation || __IS_FABRIC_DPE__;
    }

    // Owner: anredd, 2025/08/19
    public static get enableLakehouseMaintenanceActivity(): boolean {
        return this._enableLakehouseMaintenanceActivity;// && __IS_FABRIC_DPE__;
    }

    // Owner: anredd, 2025/10/06
    public static get enableRefreshMaterializedLakeViewActivity(): boolean {
        return this._enableRefreshMaterializedLakeViewActivity;// && __IS_FABRIC_DPE__;
    }

    // Owner: kalyanke, 2025/08/19
    public static get enableRefreshSqlEndpointActivity(): boolean {
        return this._enableRefreshSqlEndpointActivity;// && __IS_FABRIC_DPE__;
    }

    // Owner: anredd, 2023/10/26
    public static get enableFabricValidate(): boolean {
        return this._fabricValidate && __IS_FABRIC_DPE__;
    }

    // Owner: vinaggarwal. 2023/08/12
    public static get enableNewWebActivityLS(): boolean {
        return this._enableNewWebActivityLS || this.enable5by5 || __IS_FABRIC_DPE__;
    }

    public static get themeType(): IThemeType | undefined {
        return queryObj['feature.themeType'] as IThemeType | undefined;
    }

    public static get enablePortalThemeSetting(): boolean {
        return this._enableThemeSetting || !!this.themeType || isCIEnvironment() || !__IS_A365__;
    }

    // Owner: dvachhani, 2023/03/01, enable EventHubs CDC for MS-internals and through FF
    public static get enableEventHubsCDC(): boolean {
        return GlobalVariables.isMicrosoftInternal || GlobalVariables.enableEventHubsInCDC;
    }

    // Owner: dvachhani, 2023/09/13, enable EventHubs MDF for MS-internals and through FF
    public static get enableEventHubsMDF(): boolean {
        return GlobalVariables.isMicrosoftInternal || GlobalVariables.enableEventHubsInMDF;
    }

    // Owner: kanikagupta, 2023/09/11, enable Kafka for MS-internals and through FF
    public static get enableKafkaCDC(): boolean {
        return this.isMicrosoftInternal || GlobalVariables.enableKafkaAsLinkedService;
    }

    // Owner: zoranliu, 2023/03/24
    public static get enableDataflowInlineSinkKeyColumnValidation(): boolean {
        return this.isMicrosoftInternal;
    }

    // Owner: chuluda, 2023/04/10, using this flag for controllign ADF git autosave
    public static get enableADFGitAutoSave(): boolean {
        // Internals and MS always enabled, for externals user needs to enable Preview Experience toggle
        return this._enableADFGitAutoSave && (this.isMicrosoftInternal || GlobalVariables.fabricEnv === 'DAILY' || GlobalVariables.fabricEnv === 'DXT' || localStorageGet(LOCAL_STORAGE_ENABLE_DATA_FIRST) === 'true');
    }

    public static get enableCallout(): boolean {
        return this._enableCallout;
    }

    // Owner: chuluda, 2023/06/15, using this flag for ADF Git AutoSave in livemode
    public static get enableAutoSaveLiveMode(): boolean {
        return this._enableAutoSaveLiveMode && (this.isMicrosoftInternal || GlobalVariables.fabricEnv === 'DAILY' || GlobalVariables.fabricEnv === 'DXT' || localStorageGet(LOCAL_STORAGE_ENABLE_DATA_FIRST) === 'true');
    }

    // Owner: sekrantz, 2023/06/15
    public static get enableSimplifiedMonitoringColumns(): boolean {
        return this._enableSimplifiedMonitoringColumns || __IS_FABRIC_DPE__;
    }

    // Owner: altra, 2023/11/29
    public static get enableSecureStringGlobalParameter(): boolean {
        return this._enableSecureStringGlobalParameter || this.isMicrosoftInternal;
    }

    public static get enableConnectionSettings(): boolean {
        return this.enableTridentNewTranslationLayer && __IS_FABRIC_DPE__;
    }

    // Owner: vekandib, 2024/04/24
    public static get enableOrderedArmTemplateGeneration(): boolean {
        return this._enableOrderedArmTemplateGeneration || isDevEnvironment() || isCIEnvironment() || isStagingEnvironment();
    }

    // Owner: vekandib, 2024/04/25
    public static get enableMsiAuthForScopeActivity(): boolean {
        return this._enableMsiAuthForScopeActivity && !__IS_FABRIC_DPE__;
    }

    // Owner: vekandib, 2024/04/25
    public static get enableUamiAuthForScopeActivity(): boolean {
        return this._enableUamiAuthForScopeActivity && !__IS_FABRIC_DPE__;
    }

    // Owner: vekandib, 2024/07/23
    public static get enableSpnAuthInAzFuncActivity(): boolean {
        return this._enableSpnAuthInAzFuncActivity && !__IS_FABRIC_DPE__;
    }

    // Owner: vekandib, 2026/01/16
    public static get useGitInitializeImprove(): boolean {
        return this._useGitInitializeImprove
    }

    // Owner: anredd, 2025/02/03
    public static get enableUamiAuthInAzFuncActivity(): boolean {
        return this._enableUamiAuthForAzFuncActivity && !__IS_FABRIC_DPE__;
    }

    // Owner: vekandib, 2025/02/19
    public static get useDataflowConnection(): boolean {
        return /[\?&]feature\.dataflowConnection=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;
    }

    // Owner: anredd/vekandib, 2025/07/14
    public static get useDataflowNewParameterUi(): boolean {
        return /[\?&]feature\.dfParamDisc=true/i.test(getLocationHref()) && __IS_FABRIC_DPE__;
    }

    // Owner: akv, 2024/05/27
    public static get enableGen1MIAuthForMDF(): boolean {
        return this._enableGen1MIAuthForMDF;
    }

    /**
     * Used in A365 only, where we always have a single context.
     * !IMPORTANT DO NOT USE IN OTHER CONETXTS!!!
     */
    public static get enableSynapseLinkTargetLakehouseEC(): boolean {
        return /[\?&]feature\.enableSynapseLinkTargetLH=true/i.test(getLocationHref());
    }

    public static get enableSynapseLinkStopPausedLinkConnectionEC(): boolean {
        return /[\?&]feature\.enableSynapseLinkStopPausedLinkConnection=true/i.test(getLocationHref());
    }

    public static get enableSynapseLink(): boolean {
        return __IS_A365__ && !isA365LXEnvrionment();
    }
    public static get enableSynapseLinkCreation(): boolean {
        return GlobalVariables.enableSynapseLink &&
            (!GlobalVariables.isMicrosoftInternal || /[\?&]feature\.synapseLinkCreation=true/i.test(getLocationHref()));
    }

    // Owner: raprade, 2025/03/12
    public static get isPipelineZoomFeatureAvailable(): boolean {
        return !!getDPEFeatureFlag('pipelineZoom') || GlobalVariables.fabricEnv === 'DAILY' || GlobalVariables.isMicrosoftInternal;
    }
    public static get enablePipelineZoom(): boolean {
        return localStorageGet('pipelineZoomEnabled') === 'true';
    }
    // #endregion
}

export const immutableResourceTypes: string[] = ['table', 'relationship', 'dataMapper'];
